webpackJsonp([5],Array(42).concat([
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  "data-v-43b4dd98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SaIdNumber__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumber__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequiredIf__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RequiredUnless__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AlphaWhite__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Password__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateFormat__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DateBetween__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__SaIdNumber__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__PhoneNumber__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__RequiredIf__["a"]; });
/* unused harmony reexport requiredUnless */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__AlphaWhite__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Password__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__DateFormat__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__DateBetween__["a"]; });











/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(676),
  /* scopeId */
  "data-v-c4cddfbc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(678),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(656),
  /* scopeId */
  "data-v-4be543b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  "data-v-7fa3e0fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    context: ''
  },
  mutations: {
    setContext: function setContext(state, payload) {
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state, 'context', payload);
    }
  },
  actions: {
    updateContext: function updateContext(_ref, data) {
      var commit = _ref.commit;

      commit('setContext', data.context);
    }
  }
}));

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAtCAMAAADC6iZrAAAAM1BMVEVHcEwgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQ65IRLAAAAEHRSTlMAcM+fgEAwvxDvIGDfr49QmjkXXQAAAYpJREFUSMe1VumagyAMFAiXHOb9n3Zr1V0OQ0PbnX/64ZBjnGRZWDB6XT7AKqzHHVEF9xaDtljAq/lwXMIGXkxSGI897FRC2x0FonQfRsEiWcE+INziKArENC5ivs5BQhrbiEIiC36QjUUm6A4HLgVGkiOyOdBQLeFTkMnoCY70BQ77BY74hXrgrbyCkhMUHrrOOPA4C6vrXzTiO8gT+owbFYrj9iMaZ/1YJq1RwKJV+az2y4Dgh4NDtSXfQ/PtVUS+fr1Xxf5WdH5DRKLq0+XbpbMbRwRy5zvx+OgUnP+TEiFBXVyI1UfHrRLcS5MTPcf2m30UK8cooePIl2R8aGcGMjnkJZl6DomBAncO3xbogdSMMvPCFVMfhuksNwCITLuz6J02F24pztAMBNrQyt/lPC/LWaieZc44/GGg48CqGjatWr6YmsWQPfuJfKveukVDnbnUBR1QqH5bOSPLlVM6DsVDhLYyC5NZk7zd70IsKwJlGJRf3+yZBtK+RT2LVPZF2DvkN/fd/8QPSdxmnCqnKE8AAAAASUVORK5CYII="

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(659),
  /* scopeId */
  "data-v-58e5c1c3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(671),
  /* scopeId */
  "data-v-b233300a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(669),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */,
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Api__ = __webpack_require__(260);


function init() {
  if (!this.$api) {
    this.$api = __WEBPACK_IMPORTED_MODULE_0__Api__["a" /* default */];
  }
}

function install(Vue) {
  Vue.mixin({ beforeCreate: init });
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_NavBar__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_NavBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_common_NavBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_FooterBar__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_common_FooterBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_brochure_Brochure__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_brochure_Brochure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_brochure_Brochure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_brochure_Academic__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_brochure_Academic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_brochure_Academic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_brochure_Patient__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_brochure_Patient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_brochure_Patient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_brochure_Practice__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_brochure_Practice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_brochure_Practice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_brochure_About__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_brochure_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_brochure_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_brochure_Packages__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_brochure_Packages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_brochure_Packages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_brochure_MedEMass__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_brochure_MedEMass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_brochure_MedEMass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_brochure_PricePlans__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_brochure_PricePlans___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_brochure_PricePlans__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_user_User__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_user_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_user_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_user_Login__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_user_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_user_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_user_SignUp__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_user_SignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_user_SignUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_user_ForgotPassword__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_user_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_user_ForgotPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_user_ForgotUsername__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_user_ForgotUsername___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_user_ForgotUsername__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_user_ResetPassword__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_user_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_user_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_user_VerifyEmail__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_user_VerifyEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_user_VerifyEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_user_RequestRemoval__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_user_RequestRemoval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_user_RequestRemoval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_analytics__);


























__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Brochure',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_4_components_brochure_Brochure___default.a,
      header: __WEBPACK_IMPORTED_MODULE_2_components_common_NavBar___default.a,
      footer: __WEBPACK_IMPORTED_MODULE_3_components_common_FooterBar___default.a
    },
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_6_components_brochure_Patient___default.a
    }, {
      path: 'academic',
      name: 'Academic',
      component: __WEBPACK_IMPORTED_MODULE_5_components_brochure_Academic___default.a
    }, {
      path: 'patient',
      name: 'Patient',
      component: __WEBPACK_IMPORTED_MODULE_6_components_brochure_Patient___default.a
    }, {
      path: 'practice',
      alias: 'providers',
      name: 'Practice',
      component: __WEBPACK_IMPORTED_MODULE_7_components_brochure_Practice___default.a
    }, {
      path: 'about',
      name: 'About',
      component: __WEBPACK_IMPORTED_MODULE_8_components_brochure_About___default.a
    }, {
      path: 'packages',
      name: 'Packages',
      component: __WEBPACK_IMPORTED_MODULE_9_components_brochure_Packages___default.a
    }, {
      path: 'priceplans',
      name: 'priceplans',
      component: __WEBPACK_IMPORTED_MODULE_11_components_brochure_PricePlans___default.a
    }]
  }, {
    path: '/med-e-mass',
    name: 'MedEMass',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_10_components_brochure_MedEMass___default.a
    }
  }, {
    path: '/',
    name: 'User',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_12_components_user_User___default.a,
      header: __WEBPACK_IMPORTED_MODULE_2_components_common_NavBar___default.a
    },
    children: [{
      path: 'login/:loginContext?',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_13_components_user_Login___default.a,
      props: true
    }, {
      path: 'signup/:signupContext?',
      alias: 'register/:signupContext?',
      name: 'SignUp',
      component: __WEBPACK_IMPORTED_MODULE_14_components_user_SignUp___default.a,
      props: true
    }, {
      path: 'forgotpassword',
      name: 'ForgotPassword',
      component: __WEBPACK_IMPORTED_MODULE_15_components_user_ForgotPassword___default.a
    }, {
      path: 'forgotusername',
      name: 'ForgotUsername',
      component: __WEBPACK_IMPORTED_MODULE_16_components_user_ForgotUsername___default.a
    }, {
      path: 'passwordreset/:context/:hash',
      name: 'ResetPassword',
      component: __WEBPACK_IMPORTED_MODULE_17_components_user_ResetPassword___default.a,
      props: true
    }, {
      path: 'verifyEmail',
      name: 'VerifyEmail',
      component: __WEBPACK_IMPORTED_MODULE_18_components_user_VerifyEmail___default.a
    }, {
      path: 'requestremoval/:token',
      name: 'RequestRemoval',
      component: __WEBPACK_IMPORTED_MODULE_19_components_user_RequestRemoval___default.a
    }]
  }, {
    path: '*',
    redirect: '/'
  }]
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_vue_analytics___default.a, {
  id: 'UA-68267982-3',
  router: router
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 236 */,
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */,
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)
__webpack_require__(567)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "/api"
});

api.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
api.defaults.headers.common['dataType'] = 'json';

api.interceptors.response.use(function (response) {
  return response.data;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

function login(credentials) {
  return api.post('/v1/security/brochureLogin', {
    username: credentials.username,
    password: credentials.password
  }).then(function (data) {
    window.location.href = data.location;
  });
}

function isAccountLocked() {
  return false;
}

function registerHcp(user, inviteKey) {
  var inviteParam = inviteKey ? '?inviteKey=' + inviteKey : '';
  return api.post('/v1/signup/hcp' + inviteParam, user);
}

function registerTrainee(user, inviteKey) {
  var inviteParam = inviteKey ? '?inviteKey=' + inviteKey : '';
  return api.post('/v1/signup/trainee' + inviteParam, user);
}

function registerSupervisor(user, inviteKey) {
  var inviteParam = inviteKey ? '?inviteKey=' + inviteKey : '';
  return api.post('/v1/signup/supervisor' + inviteParam, user);
}

function registerHod(user, inviteKey) {
  var inviteParam = inviteKey ? '?inviteKey=' + inviteKey : '';
  return api.post('/v1/signup/hod' + inviteParam, user);
}

function lookupDisciplines() {
  return api.get('/v1/lookup/disciplines');
}

function lookupLogbookCountries() {
  return api.get('/v1/lookup/countries');
}

function lookupSpecialities(disciplineId) {
  return api.get('/v1/lookup/discipline/' + disciplineId + '/specialities');
}

function lookupGrades(specialityId) {
  return api.get('/v1/lookup/speciality/' + specialityId + '/grades');
}

function lookupRoles() {
  return api.get('/v2/lookups/roles');
}

function lookupInstitutions() {
  return api.get('/v2/lookups/trainingInstitutions');
}

function searchHods(query) {
  return api.get('/v2/departments/searchHod', {
    params: query
  });
}

function requestPasswordReset(username) {
  return api.post('v1/security/passwordreset/', username).then(function () {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({ otpAvailable: false });
  });
}

function performPasswordReset(credentials) {
  return api.post('v1/security/changepassword', credentials);
}

function verifyEmail(verifyEmailData) {
  return api.post('v1/signup/verifyEmail', verifyEmailData);
}

function fetchInviteData(inviteKey) {
  return api.get('v1/signup/invite/' + inviteKey);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  login: login,
  isAccountLocked: isAccountLocked,
  registerHcp: registerHcp,
  registerTrainee: registerTrainee,
  registerSupervisor: registerSupervisor,
  registerHod: registerHod,
  lookupDisciplines: lookupDisciplines,
  lookupLogbookCountries: lookupLogbookCountries,
  lookupSpecialities: lookupSpecialities,
  lookupGrades: lookupGrades,
  lookupRoles: lookupRoles,
  lookupInstitutions: lookupInstitutions,
  searchHods: searchHods,
  requestPasswordReset: requestPasswordReset,
  performPasswordReset: performPasswordReset,
  verifyEmail: verifyEmail,
  fetchInviteData: fetchInviteData
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_Ud__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_Academic__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(158);





/* harmony default export */ __webpack_exports__["a"] = ({
  validationError: 'You have not completed this form correctly. Please review each highlighted field and correct.',
  communicationError: 'There was an error communicating with the server. Please try again later.',
  invalidUsernameOrPassword: 'Invalid username and/or password supplied. Please try again.',
  accountLocked: 'The account is locked or does not exist.',
  unknownEmailAddress: 'The supplied email address does not exist.',
  unknownUsername: 'The supplied username does not exist.',

  api: function api() {
    return __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].state.context === 'academic' ? __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0_api_Ud__["a" /* default */];
  },
  processError: function processError(error) {
    if (error.response) {
      if (error.response.data) {
        return error.response.data.message || error.response.data.errorMessage;
      }

      return this.communicationError;
    }

    return this.communicationError;
  },
  login: function login(credentials) {
    return this.api().login(credentials);
  },
  isAccountLocked: function isAccountLocked(credentials) {
    return this.api().isAccountLocked(credentials);
  },
  register: function register(user, type, inviteKey) {
    switch (type) {
      case 'HCP':
        return __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */].registerHcp(user, inviteKey);
      case 'TRAINEE':
        return __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */].registerTrainee(user, inviteKey);
      case 'SUPERVISOR':
        return __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */].registerSupervisor(user, inviteKey);
      case 'HOD':
        return __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */].registerHod(user, inviteKey);
      default:
        return __WEBPACK_IMPORTED_MODULE_0_api_Ud__["a" /* default */].register(user);
    }
  },
  requestPasswordReset: function requestPasswordReset(username) {
    return this.api().requestPasswordReset(username);
  },
  performPasswordResetWithOtp: function performPasswordResetWithOtp(credentialsWithOtp) {
    var api = __WEBPACK_IMPORTED_MODULE_0_api_Ud__["a" /* default */];
    return api.performPasswordResetWithOtp(credentialsWithOtp);
  },
  requestUsernameReminder: function requestUsernameReminder(email) {
    var api = __WEBPACK_IMPORTED_MODULE_0_api_Ud__["a" /* default */];
    return api.requestUsernameReminder(email);
  },
  performPasswordReset: function performPasswordReset(credentials) {
    return this.api().performPasswordReset(credentials);
  },
  sendContactRequest: function sendContactRequest(contactMeCriteria) {
    var api = __WEBPACK_IMPORTED_MODULE_0_api_Ud__["a" /* default */];
    return api.sendContactRequest(contactMeCriteria);
  },
  lookupCountries: function lookupCountries() {
    var api = __WEBPACK_IMPORTED_MODULE_0_api_Ud__["a" /* default */];
    return api.lookupCountries();
  },
  lookupLogbookCountries: function lookupLogbookCountries() {
    return this.api().lookupLogbookCountries();
  },
  lookupDisciplines: function lookupDisciplines() {
    return this.api().lookupDisciplines();
  },
  lookupSpecialities: function lookupSpecialities(disciplineId) {
    return this.api().lookupSpecialities(disciplineId);
  },
  lookupRolesUd: function lookupRolesUd(specialityId) {
    var api = __WEBPACK_IMPORTED_MODULE_0_api_Ud__["a" /* default */];
    return api.lookupRoles(specialityId);
  },
  lookupRolesAcademic: function lookupRolesAcademic() {
    var api = __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */];
    return api.lookupRoles();
  },
  searchHods: function searchHods(query) {
    var api = __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */];
    return api.searchHods(query);
  },
  verifyEmail: function verifyEmail(verifyEmailData) {
    var api = __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */];
    return api.verifyEmail(verifyEmailData);
  },
  fetchPracticeInviteData: function fetchPracticeInviteData(inviteKey) {
    return this.api().fetchPracticeInviteData(inviteKey);
  },
  fetchInviteData: function fetchInviteData(inviteKey) {
    return this.api().fetchInviteData(inviteKey);
  },
  fetchPracticeNameAutocomplete: function fetchPracticeNameAutocomplete(searchText) {
    return this.api().fetchPracticeNameAutocomplete(searchText);
  },
  fetchPracticeKioskLink: function fetchPracticeKioskLink(practiceId) {
    return this.api().fetchPracticeKioskLink(practiceId);
  },
  validateAccountDeletionToken: function validateAccountDeletionToken(token) {
    return this.api().validateAccountDeletionToken(token);
  },
  deleteAccount: function deleteAccount(userId, token) {
    return this.api().deleteAccount(userId, token);
  },
  lookupGrades: function lookupGrades(specialityId) {
    var api = __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */];
    return api.lookupGrades(specialityId);
  },
  lookupInstitutions: function lookupInstitutions() {
    var api = __WEBPACK_IMPORTED_MODULE_1_api_Academic__["a" /* default */];
    return api.lookupInstitutions();
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);




var validateAccountDeletionToken = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', api.get('/profile/deleterequest/validate/' + token));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function validateAccountDeletionToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

var deleteAccount = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(userId, token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', api.post('/profile/deleterequest/' + userId + '/delete/' + token));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function deleteAccount(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();



var api = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: "/logboxrest_v2"
});

api.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
api.defaults.headers.common['dataType'] = 'json';

api.interceptors.response.use(function (response) {
  return response.data;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

function login(credentials) {
  var inviteCodeQuery = credentials.inviteCode ? '?inviteCode=' + credentials.inviteCode : '';

  return api.post('/security/auth' + inviteCodeQuery, credentials, {
    headers: {
      Accept: 'application/x.za.co.logbox+json; version=2',
      ClientType: 'PRACTICE_BROCHURE'
    }
  }).then(function (data) {
    window.location.href = data.location;
  });
}

function isAccountLocked(credentials) {
  return api.get('/security/' + credentials.username + '/lockedstatus');
}

function register(user) {
  return api.post('registration/register', user, {
    headers: { Accept: 'application/x.za.co.logbox+json; version=2' }
  }).then(function (data) {
    window.location.href = data.location;
  });
}

function requestPasswordReset(username) {
  return api.post('/security/password/requestReset', username, {
    headers: { Accept: 'application/x.za.co.logbox+json; version=2' }
  });
}

function performPasswordResetWithOtp(credentialsWithOtp) {
  return api.post('/security/password/processResetWithOtp', credentialsWithOtp).then(function (data) {
    window.location.href = data.location;
  });
}

function requestUsernameReminder(email) {
  return api.post('/security/username/requestReminder', email);
}

function performPasswordReset(credentials) {
  return api.post('/security/password/processReset', credentials);
}

function sendContactRequest(contactMeCriteria) {
  return api.post('/brochure/contactRequest', contactMeCriteria);
}

function lookupCountries() {
  return api.get('/lookup/countries');
}

function lookupDisciplines() {
  return api.get('/lookup/disciplines');
}

function lookupSpecialities(disciplineId) {
  return api.get('/lookup/discipline/' + disciplineId + '/specialities');
}

function lookupRoles(specialityId) {
  return api.get('/lookup/speciality/' + specialityId + '/roles');
}

function fetchPracticeInviteData(inviteKey) {
  return api.get('invite/' + inviteKey);
}

function fetchPracticeNameAutocomplete(searchText) {
  return api.get('/practice/search?name=' + searchText);
}

function fetchPracticeKioskLink(practiceId) {
  return api.get('/practice/kiosk-link/' + practiceId);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  login: login,
  isAccountLocked: isAccountLocked,
  register: register,
  requestPasswordReset: requestPasswordReset,
  performPasswordResetWithOtp: performPasswordResetWithOtp,
  requestUsernameReminder: requestUsernameReminder,
  performPasswordReset: performPasswordReset,
  sendContactRequest: sendContactRequest,
  lookupCountries: lookupCountries,
  lookupDisciplines: lookupDisciplines,
  lookupSpecialities: lookupSpecialities,
  lookupRoles: lookupRoles,
  fetchPracticeInviteData: fetchPracticeInviteData,
  fetchPracticeNameAutocomplete: fetchPracticeNameAutocomplete,
  fetchPracticeKioskLink: fetchPracticeKioskLink,
  validateAccountDeletionToken: validateAccountDeletionToken,
  deleteAccount: deleteAccount
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(234);















__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__webpack_require__(239));

new __WEBPACK_IMPORTED_MODULE_3_vue___default.a({
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);






/* harmony default export */ __webpack_exports__["a"] = (function (object) {
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(function _flatten(objectBit) {
    var _ref;

    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return (_ref = []).concat.apply(_ref, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(objectBit).map(function (key) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(objectBit[key]) === 'object' && objectBit[key] !== null) {
        return _flatten(objectBit[key], path + '/' + key);
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, path + '/' + key, objectBit[key]);
    })));
  }(object))));
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flatten__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Flatten__["a"]; });






/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }

  return (/^[a-zA-Z -]*$/.test(value)
  );
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);


function isDateBetween(value, minDateStr, maxDateStr) {
  var valueDate = new Date(value).getTime();
  var minDate = new Date(minDateStr).getTime();
  var maxDate = new Date(maxDateStr).getTime();

  return valueDate >= minDate && valueDate <= maxDate;
}

/* harmony default export */ __webpack_exports__["a"] = (function (minDate, maxDate) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate__["withParams"])({ type: 'dateBetween', min: minDate, max: maxDate }, function (value) {
    if (value === undefined || value === null || value === '') {
      return true;
    }

    return isDateBetween(value, minDate, maxDate);
  });
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function isValidDateFormat(value) {
  return (/\d{4}-\d{2}-\d{2}/.test(value)
  );
}

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (!value || value.length === 0) {
    return true;
  }

  return isValidDateFormat(value);
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }

  return (/^(?=.*[a-z])(?=.*\d).{8,}$/.test(value)
  );
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__ = __webpack_require__(576);


/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__["a" /* isValidNumber */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__["b" /* parse */])(value, { country: { default: 'ZA' } }));
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


/* harmony default export */ __webpack_exports__["a"] = (function (requiredIf) {
    return function (value, parentVm) {
        var compareTo = typeof requiredIf === 'function' ? requiredIf.call(this, parentVm) : parentVm[requiredIf];
        return !compareTo || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"])(value);
    };
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


/* unused harmony default export */ var _unused_webpack_default_export = (function (requiredUnless) {
  return function (value, parentVm) {
    var compareTo = typeof requiredUnless === 'function' ? requiredUnless.call(this, parentVm) : parentVm[requiredUnless];
    return compareTo || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"])(value);
  };
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isValidSaIdNumber(value) {
  var idNumber = value;

  if (/[^0-9-\s]+/.test(idNumber)) {
    return false;
  }

  var month = parseInt(idNumber.substring(2, 4), 10);
  var day = parseInt(idNumber.substring(4, 6), 10);

  if (month < 1 || month > 12) {
    return false;
  }

  if (day < 1 || day > 31) {
    return false;
  }

  if (month === 2 && day === 29) {
    var year = parseInt(idNumber.substring(0, 2), 10);
    if (!(year % 4 === 0 && year % 100 !== 0 || year % 400 === 0)) {
      return false;
    }
  }

  idNumber = idNumber.replace(/\D/g, '');

  var oddSum = 0;
  var evenSequence = '';
  for (var n = 0; n < idNumber.length - 1; n += 2) {
    oddSum += parseInt(idNumber.charAt(n), 10);
  }
  for (var m = 1; m < idNumber.length; m += 2) {
    evenSequence += idNumber.charAt(m);
  }
  evenSequence = parseInt(evenSequence, 10) * 2;
  evenSequence = '' + evenSequence;
  var totalEvenSequence = 0;
  for (var i = 0; i < evenSequence.length; i += 1) {
    totalEvenSequence += parseInt(('' + evenSequence).charAt(i), 10);
  }

  var total = oddSum + totalEvenSequence;
  var secondDigit = parseInt(('' + total).charAt(1), 10);
  var check = 10 - secondDigit;

  if (check > 9) {
    check = parseInt(('' + check).charAt(1), 10);
  }

  return parseInt(idNumber.charAt(12), 10) === check;
}

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }

  return isValidSaIdNumber(value);
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'float-label',
  props: {
    on: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    dispatch: {
      type: Boolean,
      default: true
    },
    for: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      formEl: undefined,
      labelEl: undefined,
      isActive: false,
      isFocused: false
    };
  },
  mounted: function mounted() {
    this.formEl = this.$el.querySelector('input, textarea, select');
    this.formEl.addEventListener('input', this.updateIsActive);
    this.formEl.addEventListener('input', this.updateIsFocused);
    this.formEl.addEventListener('blur', this.updateIsFocused);
    this.formEl.addEventListener('focus', this.updateIsFocused);

    if (!this.for) {
      this.labelEl = this.$el.querySelector('label');
      this.labelEl.addEventListener('click', this.focusFormEl);
    }

    this.dispatchInput();
  },
  beforeDestroy: function beforeDestroy() {
    this.formEl.removeEventListener('input', this.updateIsActive);
    this.formEl.removeEventListener('input', this.updateIsFocused);
    this.formEl.removeEventListener('blur', this.updateIsFocused);
    this.formEl.removeEventListener('focus', this.updateIsFocused);
  },

  methods: {
    dispatchInput: function dispatchInput() {
      if (this.dispatch) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent('input', true, false);
        this.formEl.dispatchEvent(event);
      }
    },
    focusFormEl: function focusFormEl() {
      this.formEl.focus();
    },
    updateIsActive: function updateIsActive(e) {
      this.isActive = e.target.value.length > 0;
    },
    updateIsFocused: function updateIsFocused(e) {
      this.isFocused = e.target === document.activeElement && this.isActive;
    }
  },
  computed: {
    inputId: function inputId() {
      return this.for;
    },
    classObject: function classObject() {
      return {
        'vfl-label-on-input': this.on && (this.isActive || this.fixed),
        'vfl-label-on-focus': this.isFocused
      };
    },
    formElType: function formElType() {
      return this.formEl ? this.formEl.tagName.toLowerCase() : '';
    },
    floatLabel: function floatLabel() {
      if (this.label) return this.label;

      switch (this.formElType) {
        case 'input':
        case 'textarea':
          return this.formEl.placeholder;
        case 'select':
          return this.formEl.querySelector('option[disabled][selected]').innerHTML;
        default:
          return '';
      }
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  components: {
    PartnerBranding: __WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding___default.a
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_AppLinks__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_AppLinks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_common_AppLinks__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'academic',
  components: {
    PartnerBranding: __WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding___default.a,
    AppLinks: __WEBPACK_IMPORTED_MODULE_1_components_common_AppLinks___default.a
  },
  data: function data() {
    return {
      activeTab: 1,
      links: {
        andriod: '' + "https://play.google.com/store/apps/details?id=lite.logbox.co.za.logboxlite",
        apple: '' + "https://apps.apple.com/za/app/logbox-academic/id1079785769"
      },
      specialities: ['Anaesthetics', 'Cardiothoracic Surgery', 'General Surgery', 'Internal Medicine', 'Maxillo-facial and Oral Surgery', 'Neurosurgery', 'Nuclear Medicine', 'Obstetrics & Gynaecology', 'Ophthalmology', 'Orthopaedic Surgery', 'Otorhinolaryngology', 'Paediatric Surgery', 'Plastic Surgery', 'Psychiatry', 'Urology', 'Paediatrics']
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('updateContext', {
      context: 'academic'
    });
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'brochure'
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_validators__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputText__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_outputs_ErrorDisplay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_outputs_ErrorDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_common_outputs_ErrorDisplay__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'med-e-mass',
  components: {
    InputText: __WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputText___default.a,
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_5_components_common_outputs_ErrorDisplay___default.a
  },
  data: function data() {
    return {
      loading: false,
      errorMessage: '',
      contactMeCriteria: {
        origin: 'med-e-mass-brochure',
        name: '',
        lastName: '',
        email: '',
        phoneNumber: ''
      },
      contactRequestSent: false,
      contactMeButtonTitle: 'Contact Me'
    };
  },
  validations: {
    contactMeCriteria: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        alphaWhite: __WEBPACK_IMPORTED_MODULE_3_utils_validators__["g" /* alphaWhite */]
      },
      lastName: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        alphaWhite: __WEBPACK_IMPORTED_MODULE_3_utils_validators__["g" /* alphaWhite */]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
      },
      phoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        phoneNumber: __WEBPACK_IMPORTED_MODULE_3_utils_validators__["b" /* phoneNumber */]
      }
    }
  },
  methods: {
    sendContactRequest: function sendContactRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();

                if (!_this.$v.$invalid) {
                  _context.next = 5;
                  break;
                }

                _this.errorMessage = 'Please ensure that your contact details are entered correctly.';
                _context.next = 19;
                break;

              case 5:
                _context.prev = 5;

                _this.loading = true;
                _context.next = 9;
                return _this.$api.sendContactRequest();

              case 9:

                _this.contactRequestSent = true;
                _this.contactMeButtonTitle = 'Request Sent';
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](5);

                _this.errorMessage = _this.$api.processError(_context.t0);

              case 16:
                _context.prev = 16;

                _this.loading = false;
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 13, 16, 19]]);
      }))();
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'packages',
  components: {
    UdTermsModal: function UdTermsModal() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 160));
    },
    PartnerBranding: __WEBPACK_IMPORTED_MODULE_0_components_common_PartnerBranding___default.a
  },
  data: function data() {
    return {
      modalOpen: false
    };
  },
  methods: {
    openModal: function openModal() {
      this.modalOpen = true;
    },
    closeModal: function closeModal() {
      this.modalOpen = false;
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_modals_VideoModal__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_modals_VideoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_common_modals_VideoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_PartnerBranding__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_PartnerBranding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_common_PartnerBranding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_AppLinks__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_AppLinks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_common_AppLinks__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'patient',
  components: {
    VideoModal: __WEBPACK_IMPORTED_MODULE_0_components_common_modals_VideoModal___default.a,
    PartnerBranding: __WEBPACK_IMPORTED_MODULE_1_components_common_PartnerBranding___default.a,
    AppLinks: __WEBPACK_IMPORTED_MODULE_2_components_common_AppLinks___default.a
  },
  data: function data() {
    return {
      videoModalOpen: false,
      links: {
        andriod: '' + "https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics",
        apple: '' + "https://apps.apple.com/za/app/logbox-patient/id1101708807"
      }
    };
  },
  methods: {
    openModal: function openModal() {
      this.videoModalOpen = true;
    },
    closeModal: function closeModal() {
      this.videoModalOpen = false;
    },
    navAndSetContext: function navAndSetContext(context) {
      this.$store.dispatch('updateContext', { context: context });
      this.$router.push('/' + context);
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('updateContext', {
      context: 'patient'
    });
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_modals_VideoModal__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_modals_VideoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_common_modals_VideoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_PartnerBranding__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_PartnerBranding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_common_PartnerBranding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_PracticeFeatures__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_PracticeFeatures___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_common_PracticeFeatures__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_AppLinks__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_AppLinks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_common_AppLinks__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'practice',
  components: {
    VideoModal: __WEBPACK_IMPORTED_MODULE_0_components_common_modals_VideoModal___default.a,
    PartnerBranding: __WEBPACK_IMPORTED_MODULE_1_components_common_PartnerBranding___default.a,
    PracticeFeatures: __WEBPACK_IMPORTED_MODULE_2_components_common_PracticeFeatures___default.a,
    AppLinks: __WEBPACK_IMPORTED_MODULE_3_components_common_AppLinks___default.a
  },
  data: function data() {
    return {
      videoModalOpen: false,
      links: {
        andriod: '' + "https://play.google.com/store/apps/details?id=za.co.logbox.practice",
        apple: '' + "https://apps.apple.com/za/app/logbox-practice/id1270620836"
      }
    };
  },
  methods: {
    openModal: function openModal() {
      this.videoModalOpen = true;
    },
    closeModal: function closeModal() {
      this.videoModalOpen = false;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('updateContext', {
      context: 'practice'
    });
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'priceplans',
  components: {},
  data: function data() {
    return {
      plans: [{
        name: 'Patient onBoarding',
        isCoreActive: true,
        isPremiumActive: true
      }, {
        name: 'Demographics',
        isCoreActive: true,
        isPremiumActive: true
      }, {
        name: 'Messaging Module',
        isCoreActive: true,
        isPremiumActive: true
      }, {
        name: 'Document Storage',
        isCoreActive: true,
        isPremiumActive: true
      }, {
        name: 'Integration with medical billing systems',
        isCoreActive: true,
        isPremiumActive: true
      }, {
        name: 'Clinical case collaboration for multidisciplinary teams',
        isCoreActive: false,
        isPremiumActive: true
      }, {
        name: 'Digital Clinical Notes',
        isCoreActive: false,
        isPremiumActive: true
      }, {
        name: 'Clinical Activity feed',
        isCoreActive: false,
        isPremiumActive: true
      }, {
        name: 'Customisable clinical templates',
        isCoreActive: false,
        isPremiumActive: true
      }, {
        name: 'Clinical Database creation',
        isCoreActive: false,
        isPremiumActive: true
      }, {
        name: 'Preadmissions',
        isCoreActive: false,
        isPremiumActive: true
      }, {
        name: 'Theatre lists',
        isCoreActive: false,
        isPremiumActive: true
      }, {
        name: 'Waiting List',
        isCoreActive: false,
        isPremiumActive: true
      }]
    };
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-links',
  props: {
    appLinks: {
      type: Object,
      default: {
        apple: null,
        andriod: null
      }
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'context-selector',
  computed: {
    context: function context() {
      return this.$store.state.context;
    },
    patientContext: function patientContext() {
      return {
        active: this.context === 'patient',
        inactive: this.context !== 'patient'
      };
    },
    practiceContext: function practiceContext() {
      return {
        active: this.context === 'practice',
        inactive: this.context !== 'practice'
      };
    },
    academicContext: function academicContext() {
      return {
        active: this.context === 'academic',
        inactive: this.context !== 'academic'
      };
    }
  },
  methods: {
    updateContext: function updateContext(newContext) {
      this.$store.dispatch('updateContext', {
        context: newContext
      });
      this.$parent.$emit('changeContext', {
        context: newContext
      });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(70);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer-bar',
  components: {
    PopiModal: function PopiModal() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 708));
    },
    PrivacyModal: function PrivacyModal() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 709));
    },
    UdTermsModal: function UdTermsModal() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 160));
    },
    AcademicTermsModal: function AcademicTermsModal() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 241));
    }
  },
  data: function data() {
    return {
      popiModalOpen: false,
      privacyModalOpen: false,
      udTermsModalOpen: false,
      academicTermsModalOpen: false
    };
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['context']),
  methods: {
    openModal: function openModal(type) {
      switch (type) {
        case 'popi':
          this.popiModalOpen = true;
          break;
        case 'privacy':
          this.privacyModalOpen = true;
          break;
        case 'terms':
          if (this.context === 'academic') {
            this.academicTermsModalOpen = true;
          } else {
            this.udTermsModalOpen = true;
          }
          break;
        case 'academicTerms':
          this.academicTermsModalOpen = true;
          break;
        default:
          break;
      }
    },
    closeModal: function closeModal(type) {
      switch (type) {
        case 'popi':
          this.popiModalOpen = false;
          break;
        case 'privacy':
          this.privacyModalOpen = false;
          break;
        case 'udTerms':
          this.udTermsModalOpen = false;
          break;
        case 'academicTerms':
          this.academicTermsModalOpen = false;
          break;
        default:
          break;
      }
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(70);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nav-bar',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['context'])
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'partnerBranding'
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'practice-features'
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'submit-button',
  props: {
    id: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_float_label_components_FloatLabel_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_float_label_components_FloatLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_float_label_components_FloatLabel_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'input-password',
  components: {
    FloatLabel: __WEBPACK_IMPORTED_MODULE_0_vue_float_label_components_FloatLabel_vue___default.a
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    validation: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    }
  },
  computed: {
    required: function required() {
      return !this.loading && this.validation && (this.validation.required !== undefined || !this.validation.requiredIf || this.value && this.validation.requiredIf !== undefined);
    },
    requiredError: function requiredError() {
      return this.validation && this.validation.$error && !this.validation.required && !this.validation.requiredIf;
    },
    passwordError: function passwordError() {
      return this.validation && this.validation.$error && this.validation.password !== undefined && !this.validation.password;
    },
    passwordMatchError: function passwordMatchError() {
      return this.validation && this.validation.$error && this.validation.sameAsPassword !== undefined && !this.validation.sameAsPassword;
    }
  },
  data: function data() {
    return {
      passwordNotVisible: true
    };
  },
  methods: {
    blur: function blur() {
      if (this.validation) {
        this.validation.$touch();
      }
    },
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    },
    showHidePassword: function showHidePassword() {
      this.passwordNotVisible = !this.passwordNotVisible;
    }
  },
  mounted: function mounted() {
    if (this.validation && this.required) {
      this.$refs.input.required = true;
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'input-select',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    validation: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    required: function required() {
      return !this.loading && this.validation && (this.validation.required !== undefined || !this.validation.requiredIf || this.value && this.validation.requiredIf !== undefined);
    },
    requiredError: function requiredError() {
      return this.validation && this.validation.$error && !this.validation.required && !this.validation.requiredIf;
    }
  },
  methods: {
    blur: function blur() {
      if (this.validation) {
        this.validation.$touch();
      }
    },
    updateValue: function updateValue() {
      this.$emit('input', this.selectedOption);
    }
  },
  created: function created() {
    this.selectedOption = this.value;
  },
  mounted: function mounted() {
    if (this.validation && this.required) {
      this.$refs.select.required = true;
    }
  },
  beforeUpdate: function beforeUpdate() {
    this.selectedOption = this.value;

    if (this.validation && this.required) {
      this.$refs.select.required = true;
    }
  },
  data: function data() {
    return {
      selectedOption: undefined
    };
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'input-switch',
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('input', this.selectedValue);
    }
  },
  created: function created() {
    this.selectedValue = this.value;
  },
  data: function data() {
    return {
      selectedValue: ''
    };
  },

  watch: {
    selectedValue: function selectedValue(newVal) {
      this.$emit('input', newVal);
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_float_label_components_FloatLabel_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_float_label_components_FloatLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_float_label_components_FloatLabel_vue__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'input-text',
  components: {
    FloatLabel: __WEBPACK_IMPORTED_MODULE_0_vue_float_label_components_FloatLabel_vue___default.a
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    validation: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    },
    type: {
      type: String,
      default: 'text'
    },
    minDate: {
      type: String,
      validator: function validator(value) {
        return (/\d{4}-\d{2}-\d{2}/.test(value)
        );
      },
      required: false
    },
    maxDate: {
      type: String,
      validator: function validator(value) {
        return (/\d{4}-\d{2}-\d{2}/.test(value)
        );
      },
      required: false
    }
  },
  computed: {
    required: function required() {
      return !this.loading && this.validation && (this.validation.required !== undefined || this.validation.requiredIf !== undefined);
    },
    requiredError: function requiredError() {
      return this.validation && this.validation.$error && (this.validation.required !== undefined && !this.validation.required || this.validation.requiredIf !== undefined && !this.validation.requiredIf);
    }
  },
  methods: {
    blur: function blur() {
      if (this.validation) {
        this.validation.$touch();
      }
    },
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    },
    displayIcons: function displayIcons(field) {
      switch (field) {
        case 'firstName':
          return 'glyphicon-pencil';
        case 'name':
          return 'glyphicon-pencil';
        case 'surname':
          return 'glyphicon-pencil';
        case 'lastName':
          return 'glyphicon-pencil';
        case 'username':
          return 'glyphicon-user';
        case 'emailAddress':
          return 'glyphicon-envelope';
        case 'cellularNumber':
          return 'glyphicon-phone';
        case 'cellularAddress':
          return 'glyphicon-phone';
        case 'identityNumber':
          return 'glyphicon-info-sign';
        case 'passportNumber':
          return 'glyphicon-info-sign';
        case 'practicePhone':
          return 'glyphicon-phone-alt';
        default:
          return 'glyphicon-asterisk';
      }
    }
  },
  watch: {
    label: function label(newLabel) {
      this.label = newLabel;
    }
  },
  mounted: function mounted() {
    if (this.validation && this.required) {
      this.$refs.input.required = true;
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'practice-search',
  data: function data() {
    return {
      searchText: '',
      suggestion: null,
      suggestions: null,
      suggestionFocus: false,
      showSuggestion: false
    };
  },

  methods: {
    autoComplete: function autoComplete() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.searchText.length <= 3)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return _this.$api.fetchPracticeNameAutocomplete(_this.searchText).then(function (response) {
                  _this.suggestions = response;
                }).catch(function (error) {
                  if (error.response.status === 404) {
                    _this.suggestions = [{ id: null, name: error.response.statusText }];
                    return;
                  }
                  _this.suggestions = [{ id: null, name: 'An Error Occurred While Searching' }];
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    chosen: function chosen(suggestion) {
      if (suggestion.id !== null) {
        this.$emit('practice', suggestion);
      }
      this.searchText = suggestion.name;
      this.suggestion = suggestion;
      this.clearSuggestions();
    },
    closeSuggestions: function closeSuggestions() {
      if (!this.suggestionFocus) {
        this.showSuggestion = false;
      }
    },
    onFocus: function onFocus() {
      this.suggestionFocus = false;
      this.showSuggestion = true;
    },
    clearSuggestions: function clearSuggestions() {
      this.suggestions = null;
    }
  },
  mounted: function mounted() {
    this.autoComplete();
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'base-modal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    body: function body() {
      return document.querySelector('body');
    },
    modalClass: function modalClass() {
      return {
        modal: true,
        fade: true,
        in: this.open
      };
    },
    modalBackdropClass: function modalBackdropClass() {
      return {
        'modal-backdrop': true,
        show: true,
        in: this.open
      };
    }
  },
  methods: {
    slotExists: function slotExists(slotName) {
      return this.$slots[slotName];
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.open) {
      this.body.classList.add('modal-open');
    } else {
      this.body.classList.remove('modal-open');
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_modals_BaseModal__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_modals_BaseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_common_modals_BaseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_validators__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_general__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputText__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputText__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hod-search-modal',
  props: ['open', 'specialityId', 'trainingInstituteId'],
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_3_components_common_modals_BaseModal___default.a,
    InputText: __WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputText___default.a
  },
  data: function data() {
    return {
      loading: false,
      errorMessage: '',
      filterText: '',
      hods: [],
      hodInvite: {
        emailAddress: '',
        name: ''
      }
    };
  },
  validations: {
    hodInvite: {
      emailAddress: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["email"]
      },
      name: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        alphaWhite: __WEBPACK_IMPORTED_MODULE_5_utils_validators__["g" /* alphaWhite */]
      }
    }
  },
  computed: {
    filteredHods: function filteredHods() {
      var filterKey = this.filterText && this.filterText.toLowerCase();
      var data = this.hods;

      if (filterKey) {
        data = data.filter(function (row) {
          var flatRow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_utils_general__["a" /* flatten */])(row);

          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(flatRow).some(function (key) {
            return String(flatRow[key]).toLowerCase().indexOf(filterKey) > -1;
          });
        });
      }

      return data;
    }
  },
  methods: {
    searchHods: function searchHods() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return _this.$api.searchHods({
                  searchTerm: _this.filterText,
                  speciality: _this.specialityId,
                  institute: _this.trainingInstituteId
                });

              case 4:
                _this.hods = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                _this.errorMessage = _this.$api.processError(_context.t0);

              case 10:
                _context.prev = 10;

                _this.loading = false;
                return _context.finish(10);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7, 10, 13]]);
      }))();
    },
    select: function select(hod) {
      this.$emit('close', {
        hod: hod,
        hodInvite: undefined
      });
    },
    invite: function invite() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit('close', {
          hod: undefined,
          hodInvite: this.hodInvite
        });
      }
    },
    cancel: function cancel() {
      this.$emit('close', {
        hod: undefined,
        hodInvite: undefined
      });
    }
  },
  watch: {
    open: function open(opening) {
      if (opening) {
        this.searchHods();
      } else {
        this.hods = [];
        this.filterText = '';
        this.hodInvite = {
          emailAddress: '',
          name: ''
        };
      }
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_modals_BaseModal__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_modals_BaseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_common_modals_BaseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_inputs_PracticeSearch__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_inputs_PracticeSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_common_inputs_PracticeSearch__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'kiosk-modal',
  data: function data() {
    return {
      chosenPractice: null,
      link: null,
      errorOccured: false
    };
  },

  props: {
    openModal: Boolean
  },
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_2_components_common_modals_BaseModal___default.a,
    PracticeSearch: __WEBPACK_IMPORTED_MODULE_3_components_common_inputs_PracticeSearch___default.a
  },
  methods: {
    redirectToKioskSite: function redirectToKioskSite(link) {
      if (link) {
        window.location.href = link;
      }
    },
    practice: function practice(val) {
      this.chosenPractice = val;
    },
    close: function close() {
      this.chosenPractice = null;
      this.$emit('close');
    },
    fetchKioskLink: function fetchKioskLink(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.errorOccured = false;
                _context.next = 3;
                return _this.$api.fetchPracticeKioskLink(id).then(function (response) {
                  _this.link = response.url;
                }).catch(function () {
                  _this.errorOccured = true;
                  _this.link = null;
                  _this.chosenPractice = null;
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  filters: {
    upperCase: function upperCase(val) {
      return val ? val.toUpperCase() : '';
    }
  },
  watch: {
    chosenPractice: function chosenPractice(practice) {
      if (practice) {
        this.fetchKioskLink(practice.id);
      }
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_modals_BaseModal__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_modals_BaseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_common_modals_BaseModal__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-modal',
  props: ['open'],
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_0_components_common_modals_BaseModal___default.a
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'error-display'
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_AppLinks__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_AppLinks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_common_AppLinks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_modals_KioskModal__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_modals_KioskModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_common_modals_KioskModal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'under-construction-display',
  components: {
    AppLinks: __WEBPACK_IMPORTED_MODULE_0_components_common_AppLinks___default.a,
    KioskModal: __WEBPACK_IMPORTED_MODULE_1_components_common_modals_KioskModal___default.a
  },
  data: function data() {
    return {
      openKioskModal: false
    };
  },
  props: {
    appLinks: {
      type: Object,
      default: function _default() {
        return {
          andriod: '' + "https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics",
          apple: '' + "https://apps.apple.com/za/app/logbox-patient/id1101708807"
        };
      }
    }
  },
  methods: {
    openModal: function openModal() {
      this.openKioskModal = true;
    },
    closeModal: function closeModal() {
      this.openKioskModal = false;
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_validators__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_buttons_SubmitButton__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_buttons_SubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_common_buttons_SubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_outputs_ErrorDisplay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_outputs_ErrorDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_common_outputs_ErrorDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_inputs_InputPassword__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_inputs_InputPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_common_inputs_InputPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_common_ContextSelector__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_common_ContextSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_common_ContextSelector__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'forgot-password',
  components: {
    InputText: __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_6_components_common_buttons_SubmitButton___default.a,
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_7_components_common_outputs_ErrorDisplay___default.a,
    InputPassword: __WEBPACK_IMPORTED_MODULE_8_components_common_inputs_InputPassword___default.a,
    ContextSelector: __WEBPACK_IMPORTED_MODULE_9_components_common_ContextSelector___default.a
  },
  data: function data() {
    return {
      loading: false,
      errorMessage: '',
      username: '',
      requestComplete: false,
      otpAvailable: false,
      otpValue: '',
      password: '',
      confirmPassword: ''
    };
  },
  validations: {
    username: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
    password: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
      password: __WEBPACK_IMPORTED_MODULE_4_utils_validators__["a" /* password */]
    },
    confirmPassword: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
      sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["sameAs"])(function (model) {
        return model.password;
      })
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['context']),
  methods: {
    clearSendStatus: function clearSendStatus() {
      this.errorMessage = '';
      this.otpAvailable = false;
      this.requestComplete = false;
    },
    clearOTPFields: function clearOTPFields() {
      this.otpValue = '';
      this.password = '';
      this.confirmPassword = '';
    },
    requestPasswordReset: function requestPasswordReset() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var dataVal;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.clearSendStatus();
                _context.prev = 1;

                _this.loading = true;
                _context.next = 5;
                return _this.$api.requestPasswordReset({
                  username: _this.username
                });

              case 5:
                dataVal = _context.sent;

                _this.otpAvailable = dataVal.otpAvailable;
                _this.requestComplete = true;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                _this.errorMessage = _this.$api.processError(_context.t0);
                _this.clearOTPFields();

              case 14:
                _context.prev = 14;

                _this.loading = false;
                _this.clearOTPFields();
                return _context.finish(14);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 10, 14, 18]]);
      }))();
    },
    sendPasswordResetWithOTP: function sendPasswordResetWithOTP() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$v.$touch();

                if (!_this2.$v.$invalid) {
                  _context2.next = 5;
                  break;
                }

                _this2.errorMessage = _this2.$api.validationError;
                _context2.next = 20;
                break;

              case 5:
                _this2.clearSendStatus();
                _context2.prev = 6;

                _this2.loading = true;
                _context2.next = 10;
                return _this2.$api.performPasswordResetWithOtp({
                  otp: _this2.otpValue,
                  username: _this2.username,
                  password: _this2.password
                });

              case 10:
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                _this2.errorMessage = _this2.$api.processError(_context2.t0);
                _this2.clearOTPFields();

              case 16:
                _context2.prev = 16;

                _this2.loading = false;
                _this2.clearOTPFields();
                return _context2.finish(16);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[6, 12, 16, 20]]);
      }))();
    }
  },
  mounted: function mounted() {
    if (this.$store.state.context === '') {
      this.$store.dispatch('updateContext', {
        context: 'patient'
      });
    }
    this.$on('changeContext', function () {
      this.clearSendStatus();
    });
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_inputs_InputText__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_common_inputs_InputText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_common_inputs_InputText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_buttons_SubmitButton__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_buttons_SubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_common_buttons_SubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_outputs_ErrorDisplay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_outputs_ErrorDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_common_outputs_ErrorDisplay__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'forgot-username',
  components: {
    InputText: __WEBPACK_IMPORTED_MODULE_3_components_common_inputs_InputText___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_4_components_common_buttons_SubmitButton___default.a,
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_5_components_common_outputs_ErrorDisplay___default.a
  },
  data: function data() {
    return {
      loading: false,
      errorMessage: '',
      emailAddress: '',
      requestComplete: false
    };
  },
  validations: {
    emailAddress: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
    }
  },
  methods: {
    requestUsernameReminder: function requestUsernameReminder() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;

                _context.next = 4;
                return _this.$api.requestUsernameReminder({
                  email: _this.emailAddress
                });

              case 4:

                _this.requestComplete = true;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                _this.errorMessage = _this.$api.processError(_context.t0);

              case 10:
                _context.prev = 10;

                _this.loading = false;
                return _context.finish(10);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7, 10, 13]]);
      }))();
    }
  },
  mounted: function mounted() {
    if (this.$store.state.context === '') {
      this.$store.dispatch('updateContext', {
        context: 'patient'
      });
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_ContextSelector__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_ContextSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_common_ContextSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputPassword__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_buttons_SubmitButton__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_buttons_SubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_common_buttons_SubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_outputs_ErrorDisplay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_outputs_ErrorDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_common_outputs_ErrorDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_common_outputs_UnderConstructionDisplay__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_common_outputs_UnderConstructionDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_common_outputs_UnderConstructionDisplay__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  props: ['loginContext'],
  components: {
    ContextSelector: __WEBPACK_IMPORTED_MODULE_4_components_common_ContextSelector___default.a,
    InputText: __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText___default.a,
    InputPassword: __WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputPassword___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_7_components_common_buttons_SubmitButton___default.a,
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_8_components_common_outputs_ErrorDisplay___default.a,
    UnderConstructionDisplay: __WEBPACK_IMPORTED_MODULE_9_components_common_outputs_UnderConstructionDisplay___default.a
  },
  data: function data() {
    return {
      credentials: {
        username: '',
        password: '',
        inviteCode: null
      },
      loading: false,
      error: {
        type: '',
        message: ''
      },
      links: {
        andriod: '' + "https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics",
        apple: '' + "https://apps.apple.com/za/app/logbox-patient/id1101708807"
      }
    };
  },
  validations: {
    credentials: {
      username: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
      password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['context']),
  methods: {
    saveContext: function saveContext(context) {
      this.$cookies.set('login-context', context, Infinity);
    },
    getContext: function getContext() {
      var items = [this.loginContext, this.$cookies.get('login-context'), this.context, 'patient'];
      return items.find(function (item) {
        return !!item && item.length > 0;
      });
    },
    login: function login() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var errorType, errorMessage, accountLocked;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();

                if (_this.$v.$invalid) {
                  _context.next = 25;
                  break;
                }

                _context.prev = 2;

                _this.loading = true;
                _this.saveContext(_this.context);
                _context.next = 7;
                return _this.$api.login(_this.credentials);

              case 7:
                _context.next = 22;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](2);
                errorType = '';
                errorMessage = '';

                if (_context.t0.response.status === 409 || _context.t0.response.status === 400 || _context.t0.response.status === 403 || _context.t0.response.status === 500) {
                  errorMessage = _context.t0.response.data.message || _context.t0.response.data.errorMessage;
                  errorType = _context.t0.response.data.status || _context.t0.response.data.statusCode;
                }

                if (!(_context.t0.response.status === 401)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 17;
                return _this.$api.isAccountLocked(_this.credentials);

              case 17:
                accountLocked = _context.sent;

                if (accountLocked) {
                  errorMessage = _this.$api.accountLocked;
                  errorType = 'ACCOUNT_LOCKED';
                } else {
                  errorMessage = _context.t0.response.data.message || _this.$api.invalidUsernameOrPassword;
                  errorType = '';
                }

              case 19:
                if (_context.t0.response.status === 404 || _context.t0.response.status === 503 || _context.t0.response.status === 504) {
                  errorMessage = _this.$api.communicationError;
                }

                _this.error.message = errorMessage;
                _this.error.type = errorType;

              case 22:
                _context.prev = 22;

                _this.loading = false;
                return _context.finish(22);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 9, 22, 25]]);
      }))();
    },
    getInvite: function getInvite() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var invite;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.$route.query.inviteCode) {
                  _context2.next = 11;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$api.fetchPracticeInviteData(_this2.$route.query.inviteCode);

              case 4:
                invite = _context2.sent;


                if (invite.status === 'SENT') {
                  _this2.credentials.inviteCode = invite.inviteCode;
                } else {
                  _this2.error.message = 'Invite cannot be accepted, status of invite currently is ' + invite.status;
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                if (_context2.t0.response) {
                  _this2.error.message = 'Unable to retrieve invite data';
                } else {
                  _this2.error.message = _this2.$api.communicationError;
                }

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var currentContext;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currentContext = _this3.getContext();

              if (currentContext && (currentContext === 'patient' || currentContext === 'practice' || currentContext === 'academic')) {
                _this3.$store.dispatch('updateContext', {
                  context: currentContext
                });
              } else {
                _this3.$store.dispatch('updateContext', {
                  context: ''
                });
              }
              _this3.$on('changeContext', function () {
                this.error = {};
              });

              _context3.next = 5;
              return _this3.getInvite();

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_buttons_SubmitButton__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_buttons_SubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_buttons_SubmitButton__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'request-removal',
  components: { SubmitButton: __WEBPACK_IMPORTED_MODULE_2__common_buttons_SubmitButton___default.a },
  data: function data() {
    return {
      token: null,
      validToken: false,
      loading: true,
      requestingUser: {},
      loadingRequest: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.token = _this.$route.params.token;
              _this.$api.validateAccountDeletionToken(_this.token).then(function (response) {
                _this.validToken = true;
                _this.requestingUser = response;
              }).catch(function () {
                _this.validToken = false;
              }).finally(function () {
                _this.loading = false;
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    requestRemoval: function requestRemoval() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loadingRequest = true;
                _context2.next = 3;
                return _this2.$api.deleteAccount(_this2.requestingUser.userId, _this2.token).then(function () {
                  _this2.$router.push({ name: 'Patient' });
                }).catch(function () {
                  _this2.loadingRequest = false;
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_validators__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputPassword__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_buttons_SubmitButton__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_buttons_SubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_common_buttons_SubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_outputs_ErrorDisplay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_outputs_ErrorDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_common_outputs_ErrorDisplay__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reset-password',
  components: {
    InputPassword: __WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputPassword___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_5_components_common_buttons_SubmitButton___default.a,
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_6_components_common_outputs_ErrorDisplay___default.a
  },
  data: function data() {
    return {
      loading: false,
      errorMessage: '',
      password: '',
      confirmPassword: ''
    };
  },
  props: ['context', 'hash'],
  validations: {
    password: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      password: __WEBPACK_IMPORTED_MODULE_3_utils_validators__["a" /* password */]
    },
    confirmPassword: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["sameAs"])(function (model) {
        return model.password;
      })
    }
  },
  methods: {
    performPasswordReset: function performPasswordReset() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();

                if (!_this.$v.$invalid) {
                  _context.next = 5;
                  break;
                }

                _this.errorMessage = _this.$api.validationError;
                _context.next = 18;
                break;

              case 5:
                _context.prev = 5;

                _this.loading = true;

                _context.next = 9;
                return _this.$api.performPasswordReset({
                  password: _this.password,
                  token: _this.hash
                });

              case 9:

                _this.$router.push('/login');
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](5);

                _this.errorMessage = _this.$api.processError(_context.t0);

              case 15:
                _context.prev = 15;

                _this.loading = false;
                return _context.finish(15);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 12, 15, 18]]);
      }))();
    }
  },
  mounted: function mounted() {
    if (this.context === 'ud') {
      this.$store.dispatch('updateContext', {
        context: 'patient'
      });
    } else if (this.context === 'academic') {
      this.$store.dispatch('updateContext', {
        context: 'academic'
      });
    } else {
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_ContextSelector__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_ContextSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_common_ContextSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_user_forms_AcademicForm__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_user_forms_AcademicForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_user_forms_AcademicForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_outputs_UnderConstructionDisplay__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_outputs_UnderConstructionDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_common_outputs_UnderConstructionDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_user_forms_PracticeForm__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_user_forms_PracticeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_user_forms_PracticeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_outputs_ErrorDisplay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_outputs_ErrorDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_common_outputs_ErrorDisplay__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sign-up',
  data: function data() {
    return {
      links: {
        andriod: '' + "https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics",
        apple: '' + "https://apps.apple.com/za/app/logbox-patient/id1101708807"
      }
    };
  },
  props: ['signupContext'],
  components: {
    ContextSelector: __WEBPACK_IMPORTED_MODULE_2_components_common_ContextSelector___default.a,
    AcademicForm: __WEBPACK_IMPORTED_MODULE_3_components_user_forms_AcademicForm___default.a,
    PracticeForm: __WEBPACK_IMPORTED_MODULE_5_components_user_forms_PracticeForm___default.a,
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_6_components_common_outputs_ErrorDisplay___default.a,

    UnderConstructionDisplay: __WEBPACK_IMPORTED_MODULE_4_components_common_outputs_UnderConstructionDisplay___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    currentForm: function currentForm() {
      switch (this.context) {
        case 'patient':
          return 'UnderConstructionDisplay';
        case 'practice':
          return 'PracticeForm';
        case 'academic':
          return 'AcademicForm';
        default:
          return 'UnderConstructionDisplay';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['context'])),
  mounted: function mounted() {
    if (this.signupContext && (this.signupContext === 'patient' || this.signupContext === 'practice' || this.signupContext === 'academic')) {
      this.$store.dispatch('updateContext', {
        context: this.signupContext
      });
    } else if (this.$store.state.context === '') {
      this.$store.dispatch('updateContext', {
        context: 'patient'
      });
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user'
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_outputs_ErrorDisplay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_outputs_ErrorDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_common_outputs_ErrorDisplay__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'verify-email',
  components: {
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_2_components_common_outputs_ErrorDisplay___default.a
  },
  data: function data() {
    return {
      role: '',
      verified: false,
      errorMessage: ''
    };
  },
  methods: {
    verifyEmail: function verifyEmail(verificationData) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$api.verifyEmail(verificationData);

              case 3:
                _this.verified = true;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                _this.errorMessage = _this.$api.processError(_context.t0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    redirectLogin: function redirectLogin() {
      this.$router.push('Login');
    }
  },
  mounted: function mounted() {
    this.role = this.$route.query.role;
    this.$store.dispatch('updateContext', {
      context: 'academic'
    });
    this.verifyEmail({
      emailAddress: this.$route.query.email,
      verificationCode: this.$route.query.verificationCode
    });
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_validators__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputPassword__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputSelect__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_inputs_InputSwitch__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_inputs_InputSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_common_inputs_InputSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_common_buttons_SubmitButton__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_common_buttons_SubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_common_buttons_SubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_common_modals_HodSearchModal__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_common_modals_HodSearchModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_common_modals_HodSearchModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_common_outputs_ErrorDisplay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_common_outputs_ErrorDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_common_outputs_ErrorDisplay__);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'academic-form',
  components: {
    InputText: __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputText___default.a,
    InputPassword: __WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputPassword___default.a,
    InputSelect: __WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputSelect___default.a,
    InputSwitch: __WEBPACK_IMPORTED_MODULE_8_components_common_inputs_InputSwitch___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_9_components_common_buttons_SubmitButton___default.a,
    HodSearchModal: __WEBPACK_IMPORTED_MODULE_10_components_common_modals_HodSearchModal___default.a,
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_11_components_common_outputs_ErrorDisplay___default.a,
    AcademicTermsModal: function AcademicTermsModal() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 241));
    }
  },
  data: function data() {
    return {
      loading: false,
      errorMessage: '',
      countries: [],
      disciplines: [],
      specialities: [],
      grades: [],
      roles: [],
      institutions: [],
      user: {
        username: '',
        password: '',
        name: '',
        surname: '',
        cellPhoneNumber: '',
        identityType: 'IDDOC',
        idNumber: '',
        passportNumber: '',
        passportCountryId: '',
        trainingInstitutionId: '',
        disciplineId: '',
        specialityId: '',
        specialityGradeId: '',
        hpcsaNumber: '',
        prNumber: ''
      },
      confirmPassword: '',
      academicSector: undefined,
      passportCountry: undefined,
      trainingInstitution: undefined,
      discipline: undefined,
      speciality: undefined,
      specialityGrade: undefined,
      role: undefined,
      trainee: {
        traineePostNumber: undefined,
        registrarAppointmentDate: undefined
      },
      registrarAppointmentMinDate: '1950-01-01',
      registrarAppointmentMaxDate: new Date().toLocaleDateString('en-CA'),
      supervisor: {
        hodId: '',
        clinicalUnit: ''
      },
      identityTypes: [{
        name: 'ID Document',
        value: 'IDDOC'
      }, {
        name: 'Passport',
        value: 'PASSPORT'
      }],
      academicSectorOptions: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }],
      hodSearchModalOpen: false,
      hod: undefined,
      hodInvite: undefined,
      termsModalOpen: false,
      displayHodWarning: false
    };
  },
  validations: {
    user: {
      name: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
      surname: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
      username: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"]
      },
      cellPhoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
        phoneNumber: __WEBPACK_IMPORTED_MODULE_4_utils_validators__["b" /* phoneNumber */]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
        password: __WEBPACK_IMPORTED_MODULE_4_utils_validators__["a" /* password */]
      },
      idNumber: {
        requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["c" /* requiredIf */])(function (user) {
          return user.identityType === 'IDDOC';
        }),
        saIdNumber: __WEBPACK_IMPORTED_MODULE_4_utils_validators__["d" /* saIdNumber */]
      },
      passportNumber: {
        requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["c" /* requiredIf */])(function (user) {
          return user.identityType === 'PASSPORT';
        })
      },
      passportCountryId: {
        requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["c" /* requiredIf */])(function (user) {
          return user.identityType === 'PASSPORT';
        })
      },
      disciplineId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
      specialityId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
      specialityGradeId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
      hpcsaNumber: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
      prNumber: {}
    },
    confirmPassword: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
      sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["sameAs"])(function (model) {
        return model.user.password;
      })
    },
    passportCountry: {
      requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["c" /* requiredIf */])(function (data) {
        return data.user.identityType === 'PASSPORT';
      })
    },
    discipline: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
    speciality: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
    specialityGrade: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
    academicSector: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
    trainingInstitution: {
      requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["c" /* requiredIf */])(function isInAcademicSector() {
        return this.inAcademicSector;
      })
    },
    role: {
      requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["c" /* requiredIf */])(function isInAcademicSector() {
        return this.inAcademicSector;
      })
    },
    trainee: {
      traineePostNumber: {},
      registrarAppointmentDate: {
        dateFormat: __WEBPACK_IMPORTED_MODULE_4_utils_validators__["e" /* dateFormat */],
        dateBetween: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["f" /* dateBetween */])('1950-01-01', new Date().toLocaleDateString('en-CA'))
      }
    },
    supervisor: {
      hodId: {},
      clinicalUnit: {
        requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["c" /* requiredIf */])(function () {
          return this.supervisorSignup;
        })
      }
    },
    hod: {
      requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["c" /* requiredIf */])(function () {
        return this.supervisorSignup && !this.hodInvite;
      })
    },
    hodInvite: {
      requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_validators__["c" /* requiredIf */])(function () {
        return this.supervisorSignup && !this.hod;
      })
    }
  },
  computed: {
    hodFullName: function hodFullName() {
      if (this.hod) {
        return this.hod.user.name + ' ' + this.hod.user.surname;
      } else if (this.hodInvite) {
        return this.hodInvite.name;
      }

      return '';
    },
    supervisorSignup: function supervisorSignup() {
      return this.role && this.role.name === 'SUPERVISOR';
    },
    traineeSignup: function traineeSignup() {
      return this.role && this.role.name === 'TRAINEE';
    },
    inAcademicSector: function inAcademicSector() {
      return this.academicSector && this.academicSector.value;
    },
    loadingCountries: function loadingCountries() {
      return this.countries.length === 0;
    },
    loadingDisciplines: function loadingDisciplines() {
      return this.disciplines.length === 0;
    },
    loadingSpecialities: function loadingSpecialities() {
      return this.specialities.length === 0;
    },
    loadingGrades: function loadingGrades() {
      return this.grades.length === 0;
    },
    loadingRoles: function loadingRoles() {
      return this.roles.length === 0;
    },
    loadingInstitutions: function loadingInstitutions() {
      return this.institutions.length === 0;
    },
    displayRegistarAppointmentField: function displayRegistarAppointmentField() {
      return this.traineeSignup && this.specialityGrade && this.specialityGrade.name === 'Registrar';
    }
  },
  methods: {
    loadCountries: function loadCountries() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.countries.length === 0)) {
                  _context.next = 10;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this.$api.lookupLogbookCountries();

              case 4:
                _this.countries = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

                _this.errorMessage = _this.$api.processError(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 7]]);
      }))();
    },
    loadDisciplines: function loadDisciplines() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var disciplines;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.disciplines.length === 0)) {
                  _context2.next = 11;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$api.lookupDisciplines();

              case 4:
                disciplines = _context2.sent;

                _this2.disciplines = disciplines.filter(function (discipline) {
                  return discipline.active;
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                _this2.errorMessage = _this2.$api.processError(_context2.t0);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    },
    loadSpecialities: function loadSpecialities() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var specialities;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.discipline) {
                  _context3.next = 13;
                  break;
                }

                _this3.speciality = undefined;
                _this3.specialityGrade = undefined;

                _context3.prev = 3;
                _context3.next = 6;
                return _this3.$api.lookupSpecialities(_this3.discipline.id);

              case 6:
                specialities = _context3.sent;

                _this3.specialities = specialities.filter(function (speciality) {
                  return speciality.active;
                });
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](3);

                _this3.errorMessage = _this3.$api.processError(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 10]]);
      }))();
    },
    loadGrades: function loadGrades() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this4.speciality) {
                  _context4.next = 11;
                  break;
                }

                _this4.specialityGrade = undefined;

                _context4.prev = 2;
                _context4.next = 5;
                return _this4.$api.lookupGrades(_this4.speciality.id);

              case 5:
                _this4.grades = _context4.sent;
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](2);

                _this4.errorMessage = _this4.$api.processError(_context4.t0);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[2, 8]]);
      }))();
    },
    loadRolesAndInstitutions: function loadRolesAndInstitutions() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var roles;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this5.roles.length === 0)) {
                  _context5.next = 14;
                  break;
                }

                _context5.prev = 1;
                _context5.next = 4;
                return _this5.$api.lookupInstitutions();

              case 4:
                _this5.institutions = _context5.sent;
                _context5.next = 7;
                return _this5.$api.lookupRolesAcademic();

              case 7:
                roles = _context5.sent;

                _this5.roles = roles.filter(function (role) {
                  return role !== 'HCP';
                }).map(function (role) {
                  return { name: role };
                });
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](1);

                _this5.errorMessage = _this5.$api.processError(_context5.t0);

              case 14:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[1, 11]]);
      }))();
    },
    clearIdentificationData: function clearIdentificationData() {
      switch (this.user.identityType) {
        case 'IDDOC':
          this.user.passportNumber = '';
          this.user.passportCountryId = '';
          this.passportCountry = undefined;
          break;
        case 'PASSPORT':
          this.user.idNumber = '';
          break;
        default:
          break;
      }
    },
    save: function save() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var signupRole;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this6.user, {
                  passportCountryId: _this6.passportCountry ? _this6.passportCountry.id : undefined,
                  trainingInstitutionId: _this6.trainingInstitution ? _this6.trainingInstitution.id : undefined,
                  disciplineId: _this6.discipline.id,
                  specialityId: _this6.speciality.id,
                  specialityGradeId: _this6.specialityGrade.id
                });

                signupRole = void 0;

                if (!_this6.academicSector.value) {
                  _context6.next = 14;
                  break;
                }

                signupRole = _this6.role.name;

                _context6.t0 = _this6.role.name;
                _context6.next = _context6.t0 === 'TRAINEE' ? 7 : _context6.t0 === 'SUPERVISOR' ? 9 : 11;
                break;

              case 7:
                _this6.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this6.user, _this6.trainee);
                return _context6.abrupt('break', 12);

              case 9:
                _this6.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this6.user, {
                  hodId: _this6.hod ? _this6.hod.id : undefined,
                  clinicalUnit: _this6.supervisor.clinicalUnit,
                  hodInvite: _this6.hodInvite,
                  confirmedHod: _this6.displayHodWarning
                });
                return _context6.abrupt('break', 12);

              case 11:
                return _context6.abrupt('break', 12);

              case 12:
                _context6.next = 15;
                break;

              case 14:
                signupRole = 'HCP';

              case 15:

                _this6.$v.$touch();

                if (!_this6.$v.$invalid) {
                  _context6.next = 21;
                  break;
                }

                _this6.errorMessage = _this6.$api.validationError;
                window.scrollTo(0, 0);
                _context6.next = 41;
                break;

              case 21:
                _this6.clearIdentificationData();

                _context6.prev = 22;

                _this6.loading = true;

                if (!_this6.$route.query.inviteKey) {
                  _context6.next = 29;
                  break;
                }

                _context6.next = 27;
                return _this6.$api.register(_this6.user, signupRole, _this6.$route.query.inviteKey);

              case 27:
                _context6.next = 31;
                break;

              case 29:
                _context6.next = 31;
                return _this6.$api.register(_this6.user, signupRole);

              case 31:
                _context6.next = 33;
                return _this6.$api.login({
                  username: _this6.user.username,
                  password: _this6.user.password
                });

              case 33:
                _context6.next = 38;
                break;

              case 35:
                _context6.prev = 35;
                _context6.t1 = _context6['catch'](22);

                if (_context6.t1.toString().includes('406')) {
                  _this6.displayHodWarning = true;
                } else {
                  _this6.errorMessage = _this6.$api.processError(_context6.t1);
                  window.scrollTo(0, 0);
                }

              case 38:
                _context6.prev = 38;

                _this6.loading = false;
                return _context6.finish(38);

              case 41:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[22, 35, 38, 41]]);
      }))();
    },
    openHodSearchModal: function openHodSearchModal() {
      this.hodSearchModalOpen = true;
    },
    closeHodSearchModal: function closeHodSearchModal(value) {
      this.hod = value.hod;
      this.hodInvite = value.hodInvite;

      this.hodSearchModalOpen = false;
    },
    openTermsModal: function openTermsModal() {
      this.termsModalOpen = true;
    },
    closeTermsModal: function closeTermsModal() {
      this.termsModalOpen = false;
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var inviteData;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this7.loadCountries();

            case 2:
              _context7.next = 4;
              return _this7.loadDisciplines();

            case 4:
              if (!_this7.$route.query.inviteKey) {
                _context7.next = 20;
                break;
              }

              _context7.prev = 5;
              _context7.next = 8;
              return _this7.$api.fetchInviteData(_this7.$route.query.inviteKey);

            case 8:
              inviteData = _context7.sent;


              _this7.user.username = inviteData.emailAddress;
              _this7.user.name = inviteData.name;
              _this7.academicSector = _this7.academicSectorOptions.find(function (option) {
                return option.value === true;
              });
              _context7.next = 14;
              return _this7.loadRolesAndInstitutions();

            case 14:
              _this7.role = _this7.roles.find(function (role) {
                return role.name === inviteData.role;
              });
              _context7.next = 20;
              break;

            case 17:
              _context7.prev = 17;
              _context7.t0 = _context7['catch'](5);

              if (_context7.t0.response) {
                _this7.errorMessage = 'Unable to retrieve invite data';
              } else {
                _this7.errorMessage = _this7.$api.communicationError;
              }

            case 20:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[5, 17]]);
    }))();
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_validators__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputText__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputPassword__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputSelect__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputSwitch__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_buttons_SubmitButton__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_common_buttons_SubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_common_buttons_SubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_common_outputs_ErrorDisplay__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_common_outputs_ErrorDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_common_outputs_ErrorDisplay__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'practice-form',
  components: {
    InputText: __WEBPACK_IMPORTED_MODULE_4_components_common_inputs_InputText___default.a,
    InputPassword: __WEBPACK_IMPORTED_MODULE_5_components_common_inputs_InputPassword___default.a,
    InputSelect: __WEBPACK_IMPORTED_MODULE_6_components_common_inputs_InputSelect___default.a,
    InputSwitch: __WEBPACK_IMPORTED_MODULE_7_components_common_inputs_InputSwitch___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_8_components_common_buttons_SubmitButton___default.a,
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_9_components_common_outputs_ErrorDisplay___default.a,
    UdTermsModal: function UdTermsModal() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 160));
    }
  },
  data: function data() {
    return {
      loading: false,
      errorMessage: '',
      countries: [],
      disciplines: [],
      specialities: [],
      roles: [],
      user: {
        username: '',
        password: '',
        firstname: '',
        lastname: '',
        emailAddress: '',
        cellularNumber: '',
        practicePhone: '',
        identityType: 'IDDOC',
        identityNumber: '',
        passportNumber: '',
        passportCountry: undefined,
        practiceNumber: '',
        phone: {
          number: ''
        },
        hcp: {
          discipline: undefined,
          speciality: undefined,
          role: undefined,
          hpcsaNumber: ''
        },
        inviteCode: undefined,
        type: 'HCP'
      },
      usernameType: 'CUSTOM',
      confirmPassword: '',
      identityTypes: [{
        name: 'ID Document',
        value: 'IDDOC'
      }, {
        name: 'Passport',
        value: 'PASSPORT'
      }],
      modalOpen: false
    };
  },
  validations: {
    user: {
      firstname: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
      lastname: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
      emailAddress: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
      },
      cellularNumber: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        phoneNumber: __WEBPACK_IMPORTED_MODULE_3_utils_validators__["b" /* phoneNumber */]
      },
      username: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
      password: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
      identityNumber: {
        requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validators__["c" /* requiredIf */])(function (user) {
          return user.identityType === 'IDDOC';
        }),
        saIdNumber: __WEBPACK_IMPORTED_MODULE_3_utils_validators__["d" /* saIdNumber */]
      },
      passportNumber: {
        requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validators__["c" /* requiredIf */])(function (user) {
          return user.identityType === 'PASSPORT';
        })
      },
      passportCountry: {
        requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validators__["c" /* requiredIf */])(function (user) {
          return user.identityType === 'PASSPORT';
        })
      },
      practiceNumber: {
        requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validators__["c" /* requiredIf */])(function () {
          return this.hcpSignup && !this.userInvited;
        }),
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(7),
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(7),
        numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"]
      },
      phone: {
        number: {
          phoneNumber: __WEBPACK_IMPORTED_MODULE_3_utils_validators__["b" /* phoneNumber */],
          requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validators__["c" /* requiredIf */])(function () {
            return this.hcpSignup && !this.userInvited;
          })
        }
      },
      hcp: {
        discipline: {
          requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validators__["c" /* requiredIf */])(function () {
            return this.hcpSignup;
          })
        },
        speciality: {
          requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validators__["c" /* requiredIf */])(function () {
            return this.hcpSignup;
          })
        },
        role: {
          requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validators__["c" /* requiredIf */])(function () {
            return this.hcpSignup;
          })
        },
        hpcsaNumber: {
          requiredIf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validators__["c" /* requiredIf */])(function () {
            return this.hcpSignup;
          })
        }
      }
    },
    confirmPassword: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["sameAs"])(function (data) {
        return data.user.password;
      })
    }
  },
  computed: {
    userInvited: function userInvited() {
      return this.user.inviteCode !== undefined;
    },
    hcpSignup: function hcpSignup() {
      return this.user.type === 'HCP';
    },
    loadingCountries: function loadingCountries() {
      return this.countries.length === 0;
    },
    loadingDisciplines: function loadingDisciplines() {
      return this.disciplines.length === 0;
    },
    loadingSpecialities: function loadingSpecialities() {
      return this.specialities.length === 0;
    },
    loadingRoles: function loadingRoles() {
      return this.roles.length === 0;
    }
  },
  methods: {
    clearUsername: function clearUsername() {
      this.user.username = '';
    },
    clearIdentificationData: function clearIdentificationData() {
      switch (this.user.identityType) {
        case 'IDDOC':
          this.user.passportNumber = '';
          this.user.passportCountry = undefined;
          break;
        case 'PASSPORT':
          this.user.identityNumber = '';
          break;
        default:
          break;
      }
    },
    loadCountries: function loadCountries() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.countries.length === 0)) {
                  _context.next = 10;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this.$api.lookupCountries();

              case 4:
                _this.countries = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

                _this.errorMessage = _this.$api.processError(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 7]]);
      }))();
    },
    loadDisciplines: function loadDisciplines() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.disciplines.length === 0)) {
                  _context2.next = 10;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$api.lookupDisciplines();

              case 4:
                _this2.disciplines = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](1);

                _this2.errorMessage = _this2.$api.processError(_context2.t0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 7]]);
      }))();
    },
    loadSpecialities: function loadSpecialities() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.user.hcp.discipline) {
                  _context3.next = 12;
                  break;
                }

                _this3.user.hcp.speciality = undefined;
                _this3.user.hcp.role = undefined;

                _context3.prev = 3;
                _context3.next = 6;
                return _this3.$api.lookupSpecialities(_this3.user.hcp.discipline.id);

              case 6:
                _this3.specialities = _context3.sent;
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](3);

                _this3.errorMessage = _this3.$api.processError(_context3.t0);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 9]]);
      }))();
    },
    loadRoles: function loadRoles() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this4.user.hcp.speciality) {
                  _context4.next = 11;
                  break;
                }

                _this4.user.hcp.role = undefined;

                _context4.prev = 2;
                _context4.next = 5;
                return _this4.$api.lookupRolesUd(_this4.user.hcp.speciality.id);

              case 5:
                _this4.roles = _context4.sent;
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](2);

                _this4.errorMessage = _this4.$api.processError(_context4.t0);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[2, 8]]);
      }))();
    },
    save: function save() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = _this5.usernameType;
                _context5.next = _context5.t0 === 'EMAIL' ? 3 : _context5.t0 === 'CELLULAR' ? 5 : 7;
                break;

              case 3:
                _this5.user.username = _this5.user.emailAddress;
                return _context5.abrupt('break', 8);

              case 5:
                _this5.user.username = _this5.user.cellularNumber;
                return _context5.abrupt('break', 8);

              case 7:
                return _context5.abrupt('break', 8);

              case 8:

                _this5.$v.$touch();

                if (!_this5.$v.$invalid) {
                  _context5.next = 14;
                  break;
                }

                _this5.errorMessage = _this5.$api.validationError;
                window.scrollTo(0, 0);
                _context5.next = 28;
                break;

              case 14:
                _this5.clearIdentificationData();

                _context5.prev = 15;

                _this5.loading = true;
                _context5.next = 19;
                return _this5.$api.register(_this5.user);

              case 19:
                _context5.next = 25;
                break;

              case 21:
                _context5.prev = 21;
                _context5.t1 = _context5['catch'](15);

                _this5.errorMessage = _this5.$api.processError(_context5.t1);
                window.scrollTo(0, 0);

              case 25:
                _context5.prev = 25;

                _this5.loading = false;
                return _context5.finish(25);

              case 28:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[15, 21, 25, 28]]);
      }))();
    },
    openModal: function openModal() {
      this.modalOpen = true;
    },
    closeModal: function closeModal() {
      this.modalOpen = false;
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var invite;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this6.loadCountries();
              _this6.loadDisciplines();

              if (!_this6.$route.query.inviteCode) {
                _context6.next = 13;
                break;
              }

              _context6.prev = 3;
              _context6.next = 6;
              return _this6.$api.fetchPracticeInviteData(_this6.$route.query.inviteCode);

            case 6:
              invite = _context6.sent;


              if (invite.status === 'SENT') {
                _this6.user.inviteCode = invite.inviteCode;
                _this6.user.type = invite.userType;
              } else if (invite.status === 'ACCEPTED' || invite.status === 'REGISTERED') {
                _this6.$router.push('/login');
              } else {
                _this6.errorMessage = 'Invite cannot be accepted, status of invite currently is ' + invite.status;
              }
              _context6.next = 13;
              break;

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6['catch'](3);

              if (_context6.t0.response) {
                _this6.errorMessage = 'Unable to retrieve invite data';
              } else {
                _this6.errorMessage = _this6.$api.communicationError;
              }

            case 13:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[3, 10]]);
    }))();
  }
});

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */,
/* 577 */
/***/ (function(module, exports) {

module.exports = {"country_phone_code_to_countries":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"800":["001"],"808":["001"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"870":["001"],"878":["001"],"880":["BD"],"881":["001"],"882":["001"],"883":["001"],"886":["TW"],"888":["001"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"979":["001"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","[46]\\d{4}|[01589]\\d{5}"],"AD":["376","[16]\\d{5,8}|[37-9]\\d{5}",[["(\\d{3})(\\d{3})","$1 $2",["[137-9]|6[0-8]"]],["(\\d{4})(\\d{4})","$1 $2",["180","180[02]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["690"]]]],"AE":["971","[2-79]\\d{7,8}|800\\d{2,9}",[["([2-4679])(\\d{3})(\\d{4})","$1 $2 $3",["[2-4679][2-8]"]],["(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"]],["([479]00)(\\d)(\\d{5})","$1 $2 $3",["[479]0"],"$1"],["([68]00)(\\d{2,9})","$1 $2",["60|8"],"$1"]],"0","0$1"],"AF":["93","[2-7]\\d{8}",[["([2-7]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"]]],"0","0$1"],"AG":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"268"],"AI":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"264"],"AL":["355","[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}",[["(4)(\\d{3})(\\d{4})","$1 $2 $3",["4[0-6]"]],["(6[6-9])(\\d{3})(\\d{4})","$1 $2 $3",["6"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4[7-9]"]],["(\\d{3})(\\d{3,5})","$1 $2",["[235][16-9]|8[016-9]|[79]"]]],"0","0$1"],"AM":["374","[1-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2",["1|47"]],["(\\d{2})(\\d{6})","$1 $2",["4[1349]|[5-7]|9[1-9]"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8|90"],"0 $1"]],"0","(0$1)"],"AO":["244","[29]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3"]]],"AR":["54","11\\d{8}|[2368]\\d{9}|9\\d{10}",[["([68]\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"]],["(9)(11)(\\d{4})(\\d{4})","$2 15-$3-$4",["911"],null,null,"$1 $2 $3-$4"],["(9)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9(?:2[234689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578]))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"],null,null,"$1 $2 $3-$4"],["(9)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9[23]"],null,null,"$1 $2 $3-$4"],["(11)(\\d{4})(\\d{4})","$1 $2-$3",["1"],null,"true"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578])","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"],null,"true"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["[23]"],null,"true"]],"0","0$1","0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?","9$1"],"AS":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"684"],"AT":["43","[1-9]\\d{3,12}",[["(116\\d{3})","$1",["116"],"$1"],["(1)(\\d{3,12})","$1 $2",["1"]],["(5\\d)(\\d{3,5})","$1 $2",["5[079]"]],["(5\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["5[079]"]],["(5\\d)(\\d{4})(\\d{4,7})","$1 $2 $3",["5[079]"]],["(\\d{3})(\\d{3,10})","$1 $2",["316|46|51|732|6(?:5[0-3579]|[6-9])|7(?:[28]0)|[89]"]],["(\\d{4})(\\d{3,9})","$1 $2",["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:2[1-8]|35|4[1-8]|[5-79])"]]],"0","0$1"],"AU":["61","1\\d{4,9}|[2-578]\\d{8}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[45]|14"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[38]0|90)","1(?:[38]00|90)"],"$1"],["(180)(2\\d{3})","$1 $2",["180","1802"],"$1"],["(19\\d)(\\d{3})","$1 $2",["19[13]"],"$1"],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"],"$1"],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"],"$1"]],"0",null,null,null,null,null,["[237]\\d{8}|8(?:[6-8]\\d{3}|9(?:[02-9]\\d{2}|1(?:[0-57-9]\\d|6[0135-9])))\\d{4}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,"16\\d{3,7}","550\\d{6}","13(?:00\\d{3}|45[0-4]|\\d)\\d{3}"]],"AW":["297","[25-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"AX":["358","1\\d{5,11}|[35]\\d{5,9}|[27]\\d{4,9}|4\\d{5,10}|6\\d{7,9}|8\\d{6,9}",[["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]00|[6-8]0)"]],["(116\\d{3})","$1",["116"],"$1"],["(\\d{2})(\\d{4,10})","$1 $2",["[14]|2[09]|50|7[135]"]],["(\\d)(\\d{4,11})","$1 $2",["[25689][1-8]|3"]]],"0","0$1",null,null,null,null,["18[1-8]\\d{3,9}","4\\d{5,10}|50\\d{4,8}","800\\d{4,7}","[67]00\\d{5,6}",null,null,"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})"]],"AZ":["994","[1-9]\\d{8}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["(?:1[28]|2(?:[45]2|[0-36])|365)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[4-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"]],"0","(0$1)"],"BA":["387","[3-9]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-356]|[7-9]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6[047]"]]],"0","0$1"],"BB":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"246"],"BD":["880","[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}",[["(2)(\\d{7,8})","$1-$2",["2"]],["(\\d{2})(\\d{4,6})","$1-$2",["[3-79]1"]],["(\\d{4})(\\d{3,6})","$1-$2",["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"]],["(\\d{3})(\\d{3,7})","$1-$2",["[3-79][2-9]|8"]]],"0","0$1"],"BE":["32","[1-9]\\d{7,8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[6-9]"]],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4[23]|9[2-4]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[156]|7[018]|8(?:0[1-9]|[1-79])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"]]],"0","0$1"],"BF":["226","[25-7]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"BG":["359","[23567]\\d{5,7}|[489]\\d{6,8}",[["(2)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"]],["(2)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"]],["(\\d{3})(\\d{4})","$1 $2",["43[124-7]|70[1-9]"]],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[124-7]|70[1-9]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[78]00"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["999"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["48|8[7-9]|9[08]"]]],"0","0$1"],"BH":["973","[136-9]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"BI":["257","[267]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"BJ":["229","[2689]\\d{7}|7\\d{3}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"BL":["590","[56]\\d{8}",[["([56]90)(\\d{2})(\\d{4})","$1 $2-$3"]],"0",null,null,null,null,null,["590(?:2[7-9]|5[12]|87)\\d{4}","690(?:0[0-7]|[1-9]\\d)\\d{4}"]],"BM":["1","[4589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"441"],"BN":["673","[2-578]\\d{6}",[["([2-578]\\d{2})(\\d{4})","$1 $2"]]],"BO":["591","[23467]\\d{7}",[["([234])(\\d{7})","$1 $2",["[234]"]],["([67]\\d{7})","$1",["[67]"]]],"0",null,"0(1\\d)?"],"BQ":["599","[347]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2",["[13-7]"]],["(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}","(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]],"BR":["55","[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))",[["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["[1-9][1-9]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[1-5]|7[13-579])9"],"($1)"],["(\\d{4})(\\d{4})","$1-$2",["(?:300|40(?:0|20))"]],["([3589]00)(\\d{2,3})(\\d{4})","$1 $2 $3",["[3589]00"],"0$1"]],"0",null,"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"242"],"BT":["975","[1-8]\\d{6,7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1|77"]],["([2-8])(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]]]],"BW":["267","[2-79]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],["(7\\d)(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(90)(\\d{5})","$1 $2",["9"]]]],"BY":["375","[1-4]\\d{8}|800\\d{3,7}|[89]\\d{9,10}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["17[0-3589]|2[4-9]|[34]","17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])","1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"],"8 0$1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["([89]\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8[01]|9"],"8 $1"],["(82\\d)(\\d{4})(\\d{4})","$1 $2 $3",["82"],"8 $1"],["(800)(\\d{3})","$1 $2",["800"],"8 $1"],["(800)(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"]],"8",null,"8?0?"],"BZ":["501","[2-8]\\d{6}|0\\d{10}",[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(0)(800)(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","[2-9]\\d{9}|3\\d{6}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,null,["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}|310\\d{4}","(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}","8(?:00|33|44|55|66|77|88)[2-9]\\d{6}|310\\d{4}","900[2-9]\\d{6}","5(?:00|22|33|44|66|77|88)[2-9]\\d{6}"]],"CC":["61","[1458]\\d{5,9}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[45]|14"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[38]0|90)","1(?:[38]00|90)"],"$1"],["(180)(2\\d{3})","$1 $2",["180","1802"],"$1"],["(19\\d)(\\d{3})","$1 $2",["19[13]"],"$1"],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"],"$1"],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"],"$1"]],"0",null,null,null,null,null,["89162\\d{4}","14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","190[0126]\\d{6}","500\\d{6}",null,null,null,"550\\d{6}","13(?:00\\d{2})?\\d{4}"]],"CD":["243","[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["12"]],["([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[0-2459]|9"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"]],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"]]],"0","0$1"],"CF":["236","[278]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"CG":["242","[028]\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]]]],"CH":["41","[2-9]\\d{8}|860\\d{9}",[["([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]|[89]1"]],["([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["860"]]],"0","0$1"],"CI":["225","[02-8]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"CK":["682","[2-8]\\d{4}",[["(\\d{2})(\\d{3})","$1 $2"]]],"CL":["56","(?:[2-9]|600|123)\\d{7,8}",[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[23]"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]"],"($1)"],["(9)(\\d{4})(\\d{4})","$1 $2 $3",["9"]],["(44)(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["([68]00)(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"],"$1"],["(600)(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"],"$1"],["(1230)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"$1"],["(\\d{5})(\\d{4})","$1 $2",["219"],"($1)"]],"0","0$1","0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))"],"CM":["237","[2368]\\d{7,8}",[["([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|88"]],["(800)(\\d{2})(\\d{3})","$1 $2 $3",["80"]]]],"CN":["86","[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}",[["(80\\d{2})(\\d{4})","$1 $2",["80[2678]"],"0$1","true"],["([48]00)(\\d{3})(\\d{4})","$1 $2 $3",["[48]00"]],["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2\\d)[19]","(?:10|2\\d)(?:10|9[56])","(?:10|2\\d)(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["[3-9]","[3-9]\\d{2}[19]","[3-9]\\d{2}(?:10|9[56])"],"0$1"],["(21)(\\d{4})(\\d{4,6})","$1 $2 $3",["21"],"0$1","true"],["([12]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["10[1-9]|2[02-9]","10[1-9]|2[02-9]","10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]"],"0$1","true"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],"0$1","true"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98)"],"0$1","true"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["807","8078"],"0$1","true"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-578]"]],["(10800)(\\d{3})(\\d{4})","$1 $2 $3",["108","1080","10800"]],["(\\d{3})(\\d{7,8})","$1 $2",["950"]]],"0",null,"(1(?:[129]\\d{3}|79\\d{2}))|0"],"CO":["57","(?:[13]\\d{0,3}|[24-8])\\d{7}",[["(\\d)(\\d{7})","$1 $2",["1(?:8[2-9]|9[0-3]|[2-7])|[24-8]","1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(1)(\\d{3})(\\d{7})","$1-$2-$3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"],"0$1",null,"$1 $2 $3"]],"0",null,"0([3579]|4(?:44|56))?"],"CR":["506","[24-9]\\d{7,9}",[["(\\d{4})(\\d{4})","$1 $2",["[24-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]0"]]],null,null,"(19(?:0[012468]|1[09]|20|66|77|99))"],"CU":["53","[2-57]\\d{5,7}",[["(\\d)(\\d{6,7})","$1 $2",["7"]],["(\\d{2})(\\d{4,6})","$1 $2",["[2-4]"]],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"]],"0","(0$1)"],"CV":["238","[259]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]]],"CW":["599","[169]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[13-7]"]],["(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,["9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}","9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}",null,null,null,null,null,"955\\d{5}",null,"60[0-2]\\d{4}"]],"CX":["61","[1458]\\d{5,9}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[45]|14"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[38]0|90)","1(?:[38]00|90)"],"$1"],["(180)(2\\d{3})","$1 $2",["180","1802"],"$1"],["(19\\d)(\\d{3})","$1 $2",["19[13]"],"$1"],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"],"$1"],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"],"$1"]],"0",null,null,null,null,null,["89164\\d{4}","14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","190[0126]\\d{6}","500\\d{6}",null,null,null,"550\\d{6}","13(?:00\\d{2})?\\d{4}"]],"CY":["357","[257-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2"]]],"CZ":["420","[2-8]\\d{8}|9\\d{8,11}",[["([2-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(96\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["96"]],["(9\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9[36]"]]]],"DE":["49","[1-35-9]\\d{3,14}|4(?:[0-8]\\d{4,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})",[["(1\\d{2})(\\d{7,8})","$1 $2",["1[67]"]],["(15\\d{3})(\\d{6})","$1 $2",["15[0568]"]],["(1\\d{3})(\\d{7})","$1 $2",["15"]],["(\\d{2})(\\d{3,11})","$1 $2",["3[02]|40|[68]9"]],["(\\d{3})(\\d{3,11})","$1 $2",["2(?:\\d1|0[2389]|1[24]|28|34)|3(?:[3-9][15]|40)|[4-8][1-9]1|9(?:06|[1-9]1)"]],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])","[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|4[1246]|6[1-4]|7[1346]|8[13568]|9[1246])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))"]],["(3\\d{4})(\\d{1,10})","$1 $2",["3"]],["(800)(\\d{7,12})","$1 $2",["800"]],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["(?:18|90)0|137","1(?:37|80)|900[1359]"]],["(1\\d{2})(\\d{5,11})","$1 $2",["181"]],["(18\\d{3})(\\d{6})","$1 $2",["185","1850","18500"]],["(18\\d{2})(\\d{7})","$1 $2",["18[68]"]],["(18\\d)(\\d{8})","$1 $2",["18[2-579]"]],["(700)(\\d{4})(\\d{4})","$1 $2 $3",["700"]],["(138)(\\d{4})","$1 $2",["138"]],["(15[013-68])(\\d{2})(\\d{8})","$1 $2 $3",["15[013-68]"]],["(15[279]\\d)(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"]],["(1[67]\\d)(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"]]],"0","0$1"],"DJ":["253","[27]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"DK":["45","[2-9]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"DM":["1","[57-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"767"],"DO":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"8[024]9"],"DZ":["213","(?:[1-4]|[5-9]\\d)\\d{7}",[["([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"]],["([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"]],["(9\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"]]],"0","0$1"],"EC":["593","1\\d{9,10}|[2-8]\\d{7}|9\\d{8}",[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[247]|[356][2-8]"],null,null,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(1800)(\\d{3})(\\d{3,4})","$1 $2 $3",["1"],"$1"]],"0","(0$1)"],"EE":["372","1\\d{3,4}|[3-9]\\d{6,7}|800\\d{6,7}",[["([3-79]\\d{2})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]],["(70)(\\d{2})(\\d{4})","$1 $2 $3",["70"]],["(8000)(\\d{3})(\\d{3})","$1 $2 $3",["800","8000"]],["([458]\\d{3})(\\d{3,4})","$1 $2",["40|5|8(?:00|[1-5])","40|5|8(?:00[1-9]|[1-5])"]]]],"EG":["20","1\\d{4,9}|[2456]\\d{8}|3\\d{7}|[89]\\d{8,9}",[["(\\d)(\\d{7,8})","$1 $2",["[23]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1[012]|[89]00"]],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|[89][2-9]"]]],"0","0$1"],"EH":["212","[5-9]\\d{8}",[["([5-7]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0","0$1",null,null,null,"528[89]"],"ER":["291","[178]\\d{6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3"]],"0","0$1"],"ES":["34","[5-9]\\d{8}",[["([89]00)(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[568]|[79][0-8]"]]]],"ET":["251","[1-59]\\d{8}",[["([1-59]\\d)(\\d{3})(\\d{4})","$1 $2 $3"]],"0","0$1"],"FI":["358","1\\d{4,11}|[2-9]\\d{4,10}",[["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]00|[6-8]0)"]],["(116\\d{3})","$1",["116"],"$1"],["(\\d{2})(\\d{4,10})","$1 $2",["[14]|2[09]|50|7[135]"]],["(\\d)(\\d{4,11})","$1 $2",["[25689][1-8]|3"]]],"0","0$1",null,null,null,null,["1(?:[3569][1-8]\\d{3,9}|[47]\\d{5,10})|2[1-8]\\d{3,9}|3(?:[1-8]\\d{3,9}|9\\d{4,8})|[5689][1-8]\\d{3,9}","4\\d{5,10}|50\\d{4,8}","800\\d{4,7}","[67]00\\d{5,6}",null,null,"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})"]],"FJ":["679","[35-9]\\d{6}|0\\d{10}",[["(\\d{3})(\\d{4})","$1 $2",["[35-9]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]]],"FK":["500","[2-7]\\d{4}"],"FM":["691","[39]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"FO":["298","[2-9]\\d{5}",[["(\\d{6})","$1"]],null,null,"(10(?:01|[12]0|88))"],"FR":["33","[1-9]\\d{8}",[["([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"]],["(8\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"]],"0","0$1"],"GA":["241","0?\\d{7}",[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]]],"GB":["44","\\d{7,10}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-5789]|62)","7(?:[1-5789]|624)","7(?:[1-5789]|6242)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:1|\\d1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:387|5(?:24|39)|697|768|946)","1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["([58]00)(\\d{6})","$1 $2",["[58]00"]]],"0","0$1",null,null,null,null,["2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d))\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}","7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}","80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}","(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}","70\\d{8}",null,"(?:3[0347]|55)\\d{8}","76(?:0[012]\\d|2(?:[356]\\d|4[013-9])|4[0134]\\d|5[49]\\d|6[0-369]\\d|77\\d|81\\d|9[39]\\d)\\d{5}","56\\d{8}","8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"]],"GD":["1","[4589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"473"],"GE":["995","[34578]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5"],"$1"]],"0"],"GF":["594","[56]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"GG":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-5789]|62)","7(?:[1-5789]|624)","7(?:[1-5789]|6242)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:1|\\d1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:387|5(?:24|39)|697|768|946)","1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["([58]00)(\\d{6})","$1 $2",["[58]00"]]],"0","0$1",null,null,null,null,["1481\\d{6}","7(?:781\\d|839\\d|911[17])\\d{5}","80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}","(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}","70\\d{8}",null,"(?:3[0347]|55)\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"]],"GH":["233","[235]\\d{8}|8\\d{7}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{5})","$1 $2",["8"]]],"0","0$1"],"GI":["350","[2568]\\d{7}",[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","[1-689]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]]],"GM":["220","[2-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"GN":["224","[367]\\d{7,8}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","[56]\\d{8}",[["([56]90)(\\d{2})(\\d{4})","$1 $2-$3"]],"0","0$1",null,null,null,null,["590(?:0[13468]|1[012]|2[0-68]|3[28]|4[0-8]|5[579]|6[0189]|70|8[0-689]|9\\d)\\d{4}","690(?:0[0-7]|[1-9]\\d)\\d{4}"]],"GQ":["240","[23589]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","[26-9]\\d{9}",[["([27]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2[2-9]1|[689]"]],["(2\\d{3})(\\d{6})","$1 $2",["2[2-9][02-9]"]]]],"GT":["502","[2-7]\\d{7}|1[89]\\d{9}",[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"671"],"GW":["245","(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["44|9[567]"]],["(\\d{3})(\\d{4})","$1 $2",["40"]]]],"GY":["592","[2-46-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"HK":["852","[235-7]\\d{7}|8\\d{7,8}|9\\d{4,10}",[["(\\d{4})(\\d{4})","$1 $2",["[235-7]|[89](?:0[1-9]|[1-9])"]],["(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"]],["(900)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["900"]],["(900)(\\d{2,5})","$1 $2",["900"]]]],"HN":["504","[237-9]\\d{7}",[["(\\d{4})(\\d{4})","$1-$2"]]],"HR":["385","[1-7]\\d{5,8}|[89]\\d{6,8}",[["(1)(\\d{4})(\\d{3})","$1 $2 $3",["1"]],["([2-5]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"]],["(9\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]],["(6[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"]],["([67]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"]],["(80[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["8"]],["(80[01])(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],"0","0$1"],"HT":["509","[2-489]\\d{7}",[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3"]]],"HU":["36","[1-9]\\d{7,8}",[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"]]],"06","($1)"],"ID":["62","(?:[1-79]\\d{6,10}|8\\d{7,11})",[["(\\d{2})(\\d{5,8})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,8})","$1 $2",["[4579]|2[035-9]|[36][02-9]"],"(0$1)"],["(8\\d{2})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"]],["(8\\d{2})(\\d{4})(\\d{4,5})","$1-$2-$3",["8[1-35-9]"]],["(1)(500)(\\d{3})","$1 $2 $3",["15"],"$1"],["(177)(\\d{6,8})","$1 $2",["17"]],["(800)(\\d{5,7})","$1 $2",["800"]],["(804)(\\d{3})(\\d{4})","$1 $2 $3",["804"]],["(80\\d)(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80[79]"]]],"0","0$1"],"IE":["353","[124-9]\\d{6,9}",[["(1)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"]],["(\\d{3})(\\d{5})","$1 $2",["40[24]|50[45]"]],["(48)(\\d{4})(\\d{4})","$1 $2 $3",["48"]],["(818)(\\d{3})(\\d{3})","$1 $2 $3",["81"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[24-69]|7[14]"]],["([78]\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["76|8[35-9]"],"0$1"],["(700)(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:8[059]|5)","1(?:8[059]0|5)"],"$1"]],"0","(0$1)"],"IL":["972","1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}",[["([2-489])(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["([57]\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(153)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["153"]],["(1)([7-9]\\d{2})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(1255)(\\d{3})","$1-$2",["125"]],["(1200)(\\d{3})(\\d{3})","$1-$2-$3",["120"]],["(1212)(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(1599)(\\d{6})","$1-$2",["15"]],["(\\d{4})","*$1",["[2-689]"]]],"0","$1"],"IM":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-5789]|62)","7(?:[1-5789]|624)","7(?:[1-5789]|6242)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:1|\\d1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:387|5(?:24|39)|697|768|946)","1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["([58]00)(\\d{6})","$1 $2",["[58]00"]]],"0","0$1",null,null,null,null,["1624\\d{6}","7(?:4576|[59]24\\d)\\d{5}","808162\\d{4}","(?:872299|90[0167]624)\\d{4}","70\\d{8}",null,"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}","76242\\d{5}","56\\d{8}","8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}"]],"IN":["91","008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}",[["(\\d{5})(\\d{5})","$1 $2",["600|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9]|20)|9","600|7(?:[078]|19[0-5]|2(?:[02356-9]|[14][017-9]|9[389])|3(?:[025-9]|1[07-9]|[34][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02346-9]|1[017-9]|5[017-9])|6(?:[02-9]|1[0-257-9])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:0[078]|[14][07-9]|[235-9])|3(?:[0357-9]|[126][07-9]|4[1-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9","600|7(?:0|19[0-5]|2(?:[0235679]|[14][017-9]|8(?:[0-569]|[78][089])|9[389])|3(?:[05-8]|1(?:[089]|7[5-9])|2(?:[5-8]|[0-49][089])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2345][089]|40|7[0189]))|4(?:[056]|1(?:[0135-9]|[23][089]|2[089]|4[089])|2(?:0[089]|[1-7][089]|[89])|3(?:[0-8][089]|9)|4(?:[089]|11|7[02-8])|7(?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389])|9(?:[0-7][089]|[89]))|5(?:[0346-9]|1[017-9]|2(?:[03-9]|[12][089])|5[017-9])|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]\\d|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[05-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:0(?:[08]|7[02])|[14](?:[089]|7[02-8])|[235-9])|3(?:[0357-9]|1(?:[089]|7[02-6])|2(?:[09]|77|8[0-689])|4[1-9]|6(?:[089]|7[02-7]))|[45]|6(?:[02457-9]|1(?:[089]|7[02-8])|3(?:[089]|7[02358])|6(?:[08]|7[02-8]|9[01]))|7(?:0[07-9]|[1-69]|7(?:[089]|7[02-8])|8(?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-68]))|9(?:[02-9]|1(?:[0289]|7[2-6])))|9"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-9]|80[2-46]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[59][14]|7[1257]|[68][1-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[23579]|[468][1-9])|[2-8]"]],["(\\d{2})(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3 $4",["008"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],"$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["160","1600"],"$1"],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],"$1"],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["180","1800"],"$1"],["(\\d{4})(\\d{3,4})(\\d{4})","$1 $2 $3",["186","1860"],"$1"],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18[06]"],"$1"]],"0","0$1",null,null,true],"IO":["246","3\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"IQ":["964","[1-7]\\d{7,9}",[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["([2-6]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"IR":["98","[1-8]\\d{9}|9(?:[0-4]\\d{8}|9\\d{2,8})",[["(21)(\\d{3,5})","$1 $2",["21"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"]],["(\\d{3})(\\d{3})","$1 $2",["9"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["9"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]]],"0","0$1"],"IS":["354","[4-9]\\d{6}|38\\d{7}",[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(3\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]]],"IT":["39","[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})",[["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\d{4,6})","$1 $2",["0[26]"]],["(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\d{4})(\\d{4})","$1 $2",["894","894[5-9]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,["0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})","3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","80(?:0\\d{6}|3\\d{3})","0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","1(?:78\\d|99)\\d{6}",null,null,null,"55\\d{8}","84(?:[08]\\d{6}|[17]\\d{3})"]],"JE":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-5789]|62)","7(?:[1-5789]|624)","7(?:[1-5789]|6242)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:1|\\d1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:387|5(?:24|39)|697|768|946)","1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["([58]00)(\\d{6})","$1 $2",["[58]00"]]],"0","0$1",null,null,null,null,["1534\\d{6}","7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}","80(?:07(?:35|81)|8901)\\d{4}","(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}","701511\\d{4}",null,"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}"]],"JM":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"876"],"JO":["962","[235-9]\\d{7,8}",[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(7)(\\d{4})(\\d{4})","$1 $2 $3",["7[457-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["70|8[0158]|9"]]],"0","0$1"],"JP":["81","[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})",[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"]],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]0|80[1-9]"]],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69))","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))"]],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93)","1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34])","1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))"]],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["2(?:9[14-79]|74|[34]7|[56]9)|82|993"]],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[2479][1-9]"]]],"0","0$1"],"KE":["254","20\\d{6,7}|[4-9]\\d{6,9}",[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"]],["(\\d{3})(\\d{6})","$1 $2",["7"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"]]],"0","0$1","005|0"],"KG":["996","[235-8]\\d{8,9}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[25-7]|31[25]"]],["(\\d{4})(\\d{5})","$1 $2",["3(?:1[36]|[2-9])"]],["(\\d{3})(\\d{3})(\\d)(\\d{3})","$1 $2 $3 $4",["8"]]],"0","0$1"],"KH":["855","[1-9]\\d{7,9}",[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["1\\d[1-9]|[2-9]"],"0$1"],["(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0"]]],"0"],"KI":["686","[2458]\\d{4}|3\\d{4,7}|7\\d{7}",[],null,null,"0"],"KM":["269","[3478]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]]],"KN":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"869"],"KP":["850","1\\d{9}|[28]\\d{7}",[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],"0","0$1"],"KR":["82","007\\d{9,11}|[1-7]\\d{3,9}|8\\d{8}",[["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["1(?:0|1[19]|[69]9|5[458])|[57]0","1(?:0|1[19]|[69]9|5(?:44|59|8))|[57]0"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["1(?:[01]|5[1-4]|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]","1(?:[01]|5(?:[1-3]|4[56])|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]"]],["(\\d{3})(\\d)(\\d{4})","$1-$2-$3",["131","1312"]],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["131","131[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["13[2-9]"]],["(\\d{2})(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3-$4",["30"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2[1-9]"]],["(\\d)(\\d{3,4})","$1-$2",["21[0-46-9]"]],["(\\d{2})(\\d{3,4})","$1-$2",["[3-6][1-9]1","[3-6][1-9]1(?:[0-46-9])"]],["(\\d{4})(\\d{4})","$1-$2",["1(?:5[246-9]|6[04678]|8[03579])","1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))"],"$1"]],"0","0$1","0(8[1-46-8]|85\\d{2})?"],"KW":["965","[12569]\\d{6,7}",[["(\\d{4})(\\d{3,4})","$1 $2",["[16]|2(?:[0-35-9]|4[0-35-9])|9[024-9]|52[25]"]],["(\\d{3})(\\d{5})","$1 $2",["244|5(?:[015]|66)"]]]],"KY":["1","[3589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"345"],"KZ":["7","(?:33\\d|7\\d{2}|80[09])\\d{7}",[["([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[34689]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"8",null,null,null,null,null,["33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}","7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}","800\\d{7}","809\\d{7}",null,null,null,null,"751\\d{7}"]],"LA":["856","[2-8]\\d{7,9}",[["(20)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["20"]],["([2-8]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"]],["(30)(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30"]]],"0","0$1"],"LB":["961","[13-9]\\d{6,7}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-6]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]|9"],"0$1"],["([7-9]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[89][01]|7(?:[01]|6[013-9]|8[89]|9[1-3])"]]],"0"],"LC":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"758"],"LI":["423","6\\d{8}|[23789]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[23789]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[56]"]],["(69)(7\\d{2})(\\d{4})","$1 $2 $3",["697"]]],"0",null,"0|10(?:01|20|66)"],"LK":["94","[1-9]\\d{8}",[["(\\d{2})(\\d{1})(\\d{6})","$1 $2 $3",["[1-689]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"LR":["231","2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}",[["(2\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["([4-5])(\\d{3})(\\d{3})","$1 $2 $3",["[45]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"]]],"0","0$1"],"LS":["266","[2568]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"LT":["370","[3-9]\\d{7}",[["([34]\\d)(\\d{6})","$1 $2",["37|4(?:1|5[45]|6[2-4])"]],["([3-6]\\d{2})(\\d{5})","$1 $2",["3[148]|4(?:[24]|6[09])|528|6"]],["([7-9]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1"],["(5)(2\\d{2})(\\d{4})","$1 $2 $3",["52[0-79]"]]],"8","(8-$1)","[08]",null,true],"LU":["352","[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})",[["(\\d{2})(\\d{3})","$1 $2",["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})","$1 $2 $3 $4",["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:[1-9]|0[2-9])|9(?:[1-9]|0[2-46-9])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["70|80[01]|90[015]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],null,null,"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)"],"LV":["371","[2689]\\d{7}",[["([2689]\\d)(\\d{3})(\\d{3})","$1 $2 $3"]]],"LY":["218","[25679]\\d{8}",[["([25679]\\d)(\\d{7})","$1-$2"]],"0","0$1"],"MA":["212","[5-9]\\d{8}",[["([5-7]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0","0$1",null,null,null,null,["5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}","(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[07][07]|6[12]))\\d{6}","80\\d{7}","89\\d{7}",null,null,null,null,"5924[01]\\d{4}"]],"MC":["377","[34689]\\d{7,8}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"],"$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"]],["(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"]],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["8"],"$1"]],"0","0$1"],"MD":["373","[235-9]\\d{7}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"]],["([25-7]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["2[13-9]|[5-7]"]],["([89]\\d{2})(\\d{5})","$1 $2",["[89]"]]],"0","0$1"],"ME":["382","[2-9]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]|6[036-9]"]]],"0","0$1"],"MF":["590","[56]\\d{8}",[["([56]90)(\\d{2})(\\d{4})","$1 $2-$3"]],"0",null,null,null,null,null,["590(?:[02][79]|13|5[0-268]|[78]7)\\d{4}","690(?:0[0-7]|[1-9]\\d)\\d{4}"]],"MG":["261","[23]\\d{8}",[["([23]\\d)(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"MH":["692","[2-6]\\d{6}",[["(\\d{3})(\\d{4})","$1-$2"]],"1"],"MK":["389","[2-578]\\d{7}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["([347]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[347]"]],["([58]\\d{2})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"]]],"0","0$1"],"ML":["223","[246-9]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[246-9]"]]]],"MM":["95","[1478]\\d{5,7}|[256]\\d{5,8}|9(?:[279]\\d{0,2}|[58]|[34]\\d{1,2}|6\\d?)\\d{6}",[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["1|2[245]"]],["(2)(\\d{4})(\\d{4})","$1 $2 $3",["251"]],["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["67|81"]],["(\\d{2})(\\d{2})(\\d{3,4})","$1 $2 $3",["[4-8]"]],["(9)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"]],["(9)([34]\\d{4})(\\d{4})","$1 $2 $3",["9(?:3[0-36]|4[0-57-9])"]],["(9)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92[56]"]],["(9)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["93"]]],"0","0$1"],"MN":["976","[12]\\d{7,9}|[57-9]\\d{7}",[["([12]\\d)(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"]],["([12]2\\d)(\\d{5,6})","$1 $2",["[12]2[1-3]"]],["([12]\\d{3})(\\d{5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)2"]],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"],"$1"],["([12]\\d{4})(\\d{4,5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)[4-9]"]]],"0","0$1"],"MO":["853","[268]\\d{7}",[["([268]\\d{3})(\\d{4})","$1 $2"]]],"MP":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"670"],"MQ":["596","[56]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"MR":["222","[2-48]\\d{7}",[["([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"MS":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"664"],"MT":["356","[2357-9]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"MU":["230","[2-9]\\d{6,7}",[["([2-46-9]\\d{2})(\\d{4})","$1 $2",["[2-46-9]"]],["(5\\d{3})(\\d{4})","$1 $2",["5"]]]],"MV":["960","[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})",[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9(?:[1-9]|0[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]00"]]]],"MW":["265","(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1789]"]]],"0","0$1"],"MX":["52","[1-9]\\d{9,10}",[["([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["33|55|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"]],["(1)([358]\\d)(\\d{4})(\\d{4})","044 $2 $3 $4",["1(?:33|55|81)"],"$1",null,"$1 $2 $3 $4"],["(1)(\\d{3})(\\d{3})(\\d{4})","044 $2 $3 $4",["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"],"$1",null,"$1 $2 $3 $4"]],"01","01 $1","0[12]|04[45](\\d{10})","1$1",true],"MY":["60","[13-9]\\d{7,9}",[["([4-79])(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(3)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["([18]\\d)(\\d{3})(\\d{3,4})","$1-$2 $3",["1[02-46-9][1-9]|8"],"0$1"],["(1)([36-8]00)(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]0"]],["(11)(\\d{4})(\\d{4})","$1-$2 $3",["11"],"0$1"],["(15[49])(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"]],"0"],"MZ":["258","[28]\\d{7,8}",[["([28]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-7]"]],["(80\\d)(\\d{3})(\\d{3})","$1 $2 $3",["80"]]]],"NA":["264","[68]\\d{7,8}",[["(8\\d)(\\d{3})(\\d{4})","$1 $2 $3",["8[1235]"]],["(6\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["6"]],["(88)(\\d{3})(\\d{3})","$1 $2 $3",["88"]],["(870)(\\d{3})(\\d{3})","$1 $2 $3",["870"]]],"0","0$1"],"NC":["687","[2-57-9]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-46-9]|5[0-4]"]]]],"NE":["227","[0289]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[289]|09"]],["(08)(\\d{3})(\\d{3})","$1 $2 $3",["08"]]]],"NF":["672","[13]\\d{5}",[["(\\d{2})(\\d{4})","$1 $2",["1"]],["(\\d)(\\d{5})","$1 $2",["3"]]]],"NG":["234","[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}",[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-6]|7(?:[1-79]|0[1-9])|8[2-9]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["70|8[01]|90[235-9]"]],["([78]00)(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]00"]],["([78]00)(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]00"]],["(78)(\\d{2})(\\d{3})","$1 $2 $3",["78"]]],"0","0$1"],"NI":["505","[12578]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"NL":["31","1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}",[["([1-578]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"]],["([1-5]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"]],["(6)(\\d{8})","$1 $2",["6[0-57-9]"]],["(66)(\\d{7})","$1 $2",["66"]],["(14)(\\d{3,4})","$1 $2",["14"],"$1"],["([89]0\\d)(\\d{4,7})","$1 $2",["80|9"]]],"0","0$1"],"NO":["47","0\\d{4}|[2-9]\\d{7}",[["([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}","(?:4[015-8]|5[89]|87|9\\d)\\d{6}","80[01]\\d{5}","82[09]\\d{5}","880\\d{5}","81[23]\\d{5}","0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",null,"85[0-5]\\d{5}","810(?:0[0-6]|[2-8]\\d)\\d{3}"]],"NP":["977","[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})",[["(1)(\\d{7})","$1-$2",["1[2-6]"]],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-69]|7[15-9])"]],["(9\\d{2})(\\d{7})","$1-$2",["9(?:6[013]|7[245]|8)"],"$1"]],"0","0$1"],"NR":["674","[458]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"NU":["683","[1-5]\\d{3}"],"NZ":["64","6[235-9]\\d{6}|[2-57-9]\\d{7,10}",[["([34679])(\\d{3})(\\d{4})","$1-$2 $3",["[346]|7[2-57-9]|9[1-9]"]],["(24099)(\\d{3})","$1 $2",["240","2409","24099"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["21"]],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:1[1-9]|[69]|7[0-35-9])|70|86"]],["(2\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["2[028]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|5|[89]0"]]],"0","0$1"],"OM":["968","(?:5|[279]\\d)\\d{6}|800\\d{5,6}",[["(2\\d)(\\d{6})","$1 $2",["2"]],["([79]\\d{3})(\\d{4})","$1 $2",["[79]"]],["([58]00)(\\d{4,6})","$1 $2",["[58]"]]]],"PA":["507","[1-9]\\d{6,7}",[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["6"]]]],"PE":["51","[14-9]\\d{7,8}",[["(1)(\\d{7})","$1 $2",["1"]],["([4-8]\\d)(\\d{6})","$1 $2",["[4-7]|8[2-4]"]],["(\\d{3})(\\d{5})","$1 $2",["80"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"$1"]],"0","(0$1)"],"PF":["689","4\\d{5,7}|8\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[09]|8[79]"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]]]],"PG":["675","[1-9]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[13-689]|27"]],["(\\d{4})(\\d{4})","$1 $2",["20|7"]]]],"PH":["63","2\\d{5,7}|[3-9]\\d{7,9}|1800\\d{7,9}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(2)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["([3-8]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[3-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["81|9"],"0$1"],["(1800)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(1800)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,9}|2\\d(?:111\\d{6}|\\d{3,7}))",[["(\\d{2})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"]],["(\\d{3})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"]],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"]],["(\\d{3})(\\d{6,7})","$1 $2",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d[2-9]"]],["(3\\d{2})(\\d{7})","$1 $2",["3"],"0$1"],["([15]\\d{3})(\\d{5,6})","$1 $2",["58[12]|1"]],["(586\\d{2})(\\d{5})","$1 $2",["586"]],["([89]00)(\\d{3})(\\d{2})","$1 $2 $3",["[89]00"],"0$1"]],"0","(0$1)"],"PL":["48","[12]\\d{6,8}|[3-57-9]\\d{8}|6\\d{5,8}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]],["(\\d{2})(\\d{1})(\\d{4})","$1 $2 $3",["[12]2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["26|39|5[0137]|6[0469]|7[02389]|8[08]"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})","$1 $2",["64"]]]],"PM":["508","[45]\\d{5}",[["([45]\\d)(\\d{2})(\\d{2})","$1 $2 $3"]],"0","0$1"],"PR":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"787|939"],"PS":["970","[24589]\\d{7,8}|1(?:[78]\\d{8}|[49]\\d{2,3})",[["([2489])(2\\d{2})(\\d{4})","$1 $2 $3",["[2489]"]],["(5[69]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["5"]],["(1[78]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[78]"],"$1"]],"0","0$1"],"PT":["351","[2-46-9]\\d{8}",[["(2\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["([2-46-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[3-9]|[346-9]"]]]],"PW":["680","[2-8]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"PY":["595","5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}",[["(\\d{2})(\\d{5})","$1 $2",["(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"],"(0$1)"],["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["9[1-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8700"]],["(\\d{3})(\\d{4,5})","$1 $2",["[2-8][1-9]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8][1-9]"],"0$1"]],"0"],"QA":["974","[2-8]\\d{6,7}",[["([28]\\d{2})(\\d{4})","$1 $2",["[28]"]],["([3-7]\\d{3})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","[268]\\d{8}",[["([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1",null,null,null,"262|6[49]|8"],"RO":["40","[23]\\d{5,8}|[7-9]\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"]],["(\\d{2})(\\d{4})","$1 $2",["[23]1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23][3-7]|[7-9]"]],["(2\\d{2})(\\d{3})","$1 $2",["2[3-6]"]]],"0","0$1"],"RS":["381","[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})",[["([23]\\d{2})(\\d{4,9})","$1 $2",["(?:2[389]|39)0"]],["([1-3]\\d)(\\d{5,10})","$1 $2",["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"]],["(6\\d)(\\d{6,8})","$1 $2",["6"]],["([89]\\d{2})(\\d{3,9})","$1 $2",["[89]"]],["(7[26])(\\d{4,9})","$1 $2",["7[26]"]],["(7[08]\\d)(\\d{4,9})","$1 $2",["7[08]"]]],"0","0$1"],"RU":["7","[3489]\\d{9}",[["([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[34689]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"8","8 ($1)",null,null,true,null,["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}","9\\d{9}","80[04]\\d{7}","80[39]\\d{7}"]],"RW":["250","[027-9]\\d{7,8}",[["(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"$1"],["([7-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(0\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],"0"],"SA":["966","1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}",[["([1-467])(\\d{3})(\\d{4})","$1 $2 $3",["[1-467]"]],["(1\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[1-467]"]],["(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"]],["(92\\d{2})(\\d{5})","$1 $2",["92"],"$1"],["(800)(\\d{3})(\\d{4})","$1 $2 $3",["80"],"$1"],["(811)(\\d{3})(\\d{3,4})","$1 $2 $3",["81"]]],"0","0$1"],"SB":["677","[1-9]\\d{4,6}",[["(\\d{2})(\\d{5})","$1 $2",["[7-9]"]]]],"SC":["248","[24689]\\d{5,6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]"]]]],"SD":["249","[19]\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3"]],"0","0$1"],"SE":["46","[1-35-9]\\d{5,11}|4\\d{6,8}",[["(8)(\\d{2,3})(\\d{2,3})(\\d{2})","$1-$2 $3 $4",["8"],null,null,"$1 $2 $3 $4"],["([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"],null,null,"$1 $2 $3 $4"],["([1-469]\\d)(\\d{3})(\\d{2})","$1-$2 $3",["1[136]|2[136]|3[356]|4[0246]|6[03]|90"],null,null,"$1 $2 $3"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3"],["(7\\d)(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["7"],null,null,"$1 $2 $3 $4"],["(77)(\\d{2})(\\d{2})","$1-$2$3",["7"],null,null,"$1 $2 $3"],["(20)(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],null,null,"$1 $2 $3"],["(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9[034]"],null,null,"$1 $2 $3 $4"],["(9[034]\\d)(\\d{4})","$1-$2",["9[034]"],null,null,"$1 $2"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["25[245]|67[3-6]"],null,null,"$1 $2 $3 $4 $5"]],"0","0$1"],"SG":["65","[36]\\d{7}|[17-9]\\d{7,10}",[["([3689]\\d{3})(\\d{4})","$1 $2",["[369]|8[1-9]"]],["(1[89]00)(\\d{3})(\\d{4})","$1 $2 $3",["1[89]"]],["(7000)(\\d{4})(\\d{3})","$1 $2 $3",["70"]],["(800)(\\d{3})(\\d{4})","$1 $2 $3",["80"]]]],"SH":["290","[256]\\d{4}",[],null,null,null,null,null,null,["2(?:[0-57-9]\\d|6[4-9])\\d{2}","[56]\\d{4}",null,null,null,null,null,null,"262\\d{2}"]],"SI":["386","[1-7]\\d{6,7}|[89]\\d{4,7}",[["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[12]|3[24-8]|4[24-8]|5[2-8]|7[3-8]"],"(0$1)"],["([3-7]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"]],["([89][09])(\\d{3,6})","$1 $2",["[89][09]"]],["([58]\\d{2})(\\d{5})","$1 $2",["59|8[1-3]"]]],"0","0$1"],"SJ":["47","0\\d{4}|[45789]\\d{7}",[["([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,["79\\d{6}","(?:4[015-8]|5[89]|9\\d)\\d{6}","80[01]\\d{5}","82[09]\\d{5}","880\\d{5}","81[23]\\d{5}","0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",null,"85[0-5]\\d{5}","810(?:0[0-6]|[2-8]\\d)\\d{3}"]],"SK":["421","(?:[2-68]\\d{5,8}|9\\d{6,8})",[["(2)(1[67])(\\d{3,4})","$1 $2 $3",["21[67]"]],["([3-5]\\d)(1[67])(\\d{2,3})","$1 $2 $3",["[3-5]"]],["(2)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"]],["([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"]],["([689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"]],["(9090)(\\d{3})","$1 $2",["9090"]]],"0","0$1"],"SL":["232","[2-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2"]],"0","(0$1)"],"SM":["378","[05-7]\\d{7,9}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(0549)(\\d{6})","$1 $2",["0"],null,null,"($1) $2"],["(\\d{6})","0549 $1",["[89]"],null,null,"(0549) $1"]],null,null,"(?:0549)?([89]\\d{5})","0549$1"],"SN":["221","[3789]\\d{8}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"SO":["252","[1-9]\\d{5,8}",[["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["2[0-79]|[13-5]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{2})(\\d{5,7})","$1 $2",["15|28|6[1-35-9]|799|9[2-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3[59]|4[89]|6[24-6]|79|8[08]|90"]]],"0"],"SR":["597","[2-8]\\d{5,6}",[["(\\d{3})(\\d{3})","$1-$2",["[2-4]|5[2-58]"]],["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","[19]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",null,"0$1"]],"0"],"ST":["239","[29]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"SV":["503","[267]\\d{7}|[89]\\d{6}(?:\\d{4})?",[["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"721"],"SY":["963","[1-59]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0","0$1",null,null,true],"SZ":["268","[027]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2",["[027]"]]]],"TA":["290","8\\d{3}",[],null,null,null,null,null,null,["8\\d{3}"]],"TC":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"649"],"TD":["235","[2679]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"TG":["228","[29]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[29]"]]]],"TH":["66","[2-9]\\d{7,8}|1\\d{3}(?:\\d{5,6})?",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["([13-9]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["14|[3-9]"]],["(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1"],"$1"]],"0","0$1"],"TJ":["992","[3-57-9]\\d{8}",[["([349]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["([457-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[148]|[578]|9(?:1[59]|[0235-9])"]],["(331700)(\\d)(\\d{2})","$1 $2 $3",["331","3317","33170","331700"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]","3(?:[1245]|3(?:[02-9]|1[0-589]))"]]],"8","$1",null,null,true],"TK":["690","[2-47]\\d{3,6}"],"TL":["670","[2-489]\\d{6}|7\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[2-489]"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","[1-6]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"]],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["13|[2-5]"]]],"8","(8 $1)"],"TN":["216","[2-57-9]\\d{7}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3"]]],"TO":["676","[02-8]\\d{4,6}",[["(\\d{2})(\\d{3})","$1-$2",["[1-6]|7[0-4]|8[05]"]],["(\\d{3})(\\d{4})","$1 $2",["7[5-9]|8[47-9]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]]]],"TR":["90","[2-589]\\d{9}|444\\d{4}",[["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4(?:[0-35-9]|4[0-35-9])"],"(0$1)","true"],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[02-69]"],"0$1","true"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["51|[89]"],"0$1","true"],["(444)(\\d{1})(\\d{3})","$1 $2 $3",["444"]]],"0"],"TT":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"868"],"TV":["688","[279]\\d{4,6}"],"TW":["886","2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}",[["(20)(\\d)(\\d{4})","$1 $2 $3",["202"]],["(20)(\\d{3})(\\d{4})","$1 $2 $3",["20[013-9]"]],["([2-8])(\\d{3,4})(\\d{4})","$1 $2 $3",["2[23-8]|[3-6]|[78][1-9]"]],["([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["80|9"]],["(70)(\\d{4})(\\d{4})","$1 $2 $3",["70"]]],"0","0$1"],"TZ":["255","\\d{9}",[["([24]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[24]"]],["([67]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"]],["([89]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"]]],"0","0$1"],"UA":["380","[3-9]\\d{8}",[["([3-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[38]9|4(?:[45][0-5]|87)|5(?:0|6[37]|7[37])|6[36-8]|7|9[1-9]","[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"]],["([3-689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["3[1-8]2|4[13678]2|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90","3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90"]],["([3-6]\\d{3})(\\d{5})","$1 $2",["3(?:5[013-9]|[1-46-8])|4(?:[137][013-9]|6|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6[0135-9]|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])","3(?:5[013-9]|[1-46-8](?:22|[013-9]))|4(?:[137][013-9]|6(?:[013-9]|22)|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6(?:3[02389]|[015689])|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])"]]],"0","0$1"],"UG":["256","\\d{9}",[["(\\d{3})(\\d{6})","$1 $2",["[7-9]|20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])"]],["(\\d{2})(\\d{7})","$1 $2",["3|4(?:[1-5]|6[0-36-9])"]],["(2024)(\\d{5})","$1 $2",["2024"]]],"0","0$1"],"US":["1","[2-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,true,null,["(?:2(?:0[1-35-9]|1[02-9]|2[04589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[014679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[0459]))[2-9]\\d{6}",null,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}","900[2-9]\\d{6}","5(?:00|22|33|44|66|77|88)[2-9]\\d{6}"]],"UY":["598","[2489]\\d{6,7}",[["(\\d{4})(\\d{4})","$1 $2",["[24]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9[1-9]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["[89]0"],"0$1"]],"0"],"UZ":["998","[679]\\d{8}",[["([679]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"8","8 $1"],"VA":["39","(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))",[["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\d{4,6})","$1 $2",["0[26]"]],["(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\d{4})(\\d{4})","$1 $2",["894","894[5-9]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,["06698\\d{5}","3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","80(?:0\\d{6}|3\\d{3})","0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","1(?:78\\d|99)\\d{6}",null,null,null,"55\\d{8}","84(?:[08]\\d{6}|[17]\\d{3})"]],"VC":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"784"],"VE":["58","[24589]\\d{9}",[["(\\d{3})(\\d{7})","$1-$2"]],"0","0$1"],"VG":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"284"],"VI":["1","[3589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"340"],"VN":["84","[167]\\d{6,9}|[2-59]\\d{7,9}|8\\d{6,8}",[["([17]99)(\\d{4})","$1 $2",["[17]99"]],["([48])(\\d{4})(\\d{4})","$1 $2 $3",["4|8(?:[1-57]|[689][0-79])"]],["([235-7]\\d)(\\d{4})(\\d{3})","$1 $2 $3",["2[025-79]|3[0136-9]|5[2-9]|6[0-46-8]|7[02-79]"]],["(80)(\\d{5})","$1 $2",["80"]],["(69\\d)(\\d{4,5})","$1 $2",["69"]],["([235-7]\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["2[1348]|3[25]|5[01]|65|7[18]"]],["([89]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8[689]8|9"]],["(1[2689]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[26]|8[68]|99)"]],["(1[89]00)(\\d{4,6})","$1 $2",["1[89]0"],"$1"]],"0","0$1",null,null,true],"VU":["678","[2-57-9]\\d{4,6}",[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]]],"WF":["681","[4-8]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]]],"WS":["685","[2-8]\\d{4,6}",[["(8\\d{2})(\\d{3,4})","$1 $2",["8"]],["(7\\d)(\\d{5})","$1 $2",["7"]],["(\\d{5})","$1",["[2-6]"]]]],"YE":["967","[1-7]\\d{6,8}",[["([1-7])(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"]],["(7\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7[0137]"]]],"0","0$1"],"YT":["262","[268]\\d{8}",[["([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1",null,null,null,"269|63"],"ZA":["27","[1-79]\\d{8}|8\\d{4,8}",[["(860)(\\d{3})(\\d{3})","$1 $2 $3",["860"]],["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-79]|8(?:[0-57]|6[1-9])"]]],"0","0$1"],"ZM":["260","[289]\\d{8}",[["([29]\\d)(\\d{7})","$1 $2",["[29]"]],["(800)(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],"0","0$1"],"ZW":["263","2(?:[012457-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-79]\\d{4,9}|8[06]\\d{8}",[["([49])(\\d{3})(\\d{2,4})","$1 $2 $3",["4|9[2-9]"]],["(7\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["7"]],["(86\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["86[24]"]],["([2356]\\d{2})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8|[78])|3(?:08|17|3[78]|7[1569]|8[37]|98)|5[15][78]|6(?:[29]8|[38]7|6[78]|75|[89]8)"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|6[14]|7[35]|84)|329"]],["([1-356]\\d)(\\d{3,5})","$1 $2",["1[3-9]|2[0569]|3[0-69]|5[05689]|6[0-46-9]"]],["([235]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[23]9|54"]],["([25]\\d{3})(\\d{3,5})","$1 $2",["(?:25|54)8","258[23]|5483"]],["(8\\d{3})(\\d{6})","$1 $2",["86"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]]],"0","0$1"],"001":["979","\\d{9}",[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3"]]]}}

/***/ }),
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/Academic_Text.0e61b52.png";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/Group_Elephant_Logo.c6b3ec9.svg";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/Patient_Text.881deba.png";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/Practice_Text.b772cae.png";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/1.2d72cfd.png";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/2.6e233e2.png";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/3.0b49d96.png";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/4.43ddc28.png";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/5.c5a962c.png";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/6.86a47a4.png";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/screen10.d71add8.png";

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/share-with-practice.7166f14.png";

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/TrustBy_Ampath.4d4458f.png";

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/TrustBy_DGMC.f878c6e.png";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/TrustBy_GoodX.e16de81.png";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/TrustBy_Healthrad.39e0b8e.jpg";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/TrustBy_Lancet.525fa86.jpg";

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/TrustBy_Medemass.837e260.png";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/TrustBy_Netcare.67798f1.jpg";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/TrustBy_Promed.2498af3.jpg";

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/elex-logbox.de68051.jpg";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/medi-mass-footer.6f9b16a.jpg";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/medi-mass-header.9ce0452.jpg";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/screen.abd50ab.jpg";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/screenLeft.c12a9dc.jpg";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/splash-main6.7a8d2e2.png";

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAkCAMAAAAaR1JBAAAB11BMVEVHcEwgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPQgxPTU0E5PAAAAnHRSTlMAxi3yBfzP6QEGA/7fRBVSC7So1lPTsOX9GvcTnjZFy8WMupoCapN9Lq4s+cNHVCC43g5Jlk44YPoqbx8JhCse3A1X6gf0YVFZ0aXktXdIi4AEzY+Zf0EndBe8rErVl4KrWOPEyWfYI/Z1GEZLQDobPxKHgQpr1+sI8NA+TXvijlWn2VbhqnZ65jBtXBnxc3Fj3anMytKm86DtvuwVPxFaAAAB10lEQVQYGbXBA9fbYAAG0Kdcarefbds2Ztu2bdve82P3pk3TnCTf0p2d3Yv/4cXbj58+THxeejmIv3Crw0VFc2Mp8hTeS62BdV7ko9BGndXFsFa8kQY7R7CisfVVFdH+LuyniWqsoKayiLLYZppaC1NSCf+s3AMzB2ilGyacblopgQm7j1b2bIDRKVpyFMLoPC0V2GF0zkFL26Ajna4+3ExLu+JOaAVamKfyXuRs99Hc0RPHXdTZh6w1VDmuXmPOwTPeIy7qXUTGVhdV0w3B+E0qqk4C4VEahCDzuKlxBQjGmFZ0DLJ66nWGIZRRKwDgPtNsSJvxU28KQh016iA0+Sj4S5HxgHpfIVQw59B1CLfJG5GhHVD0UO8LhE6qUu0QPIm7d4aRk6TeMgQ/VSHI7nUEkTU8P/dkgHopCDZmNULWFpWg6qOZBIQeKgr6IFxOjiNHmnva2z9LnSiE3VRMeCAELkFxoR3C5MLQLHVeQfAkmNECWW0rFN7WR8D8cxo8noSsjBluCUJtE7KkSDJCE1PI2MK0N68hhOxQPaOZTciqZ9o7CINnoRqliUrkdC9S+DYGwNkgQTETo8HDNmiNxL+7l3/8HAfgrIHi/a9VWtOpxaWFLvyT3/YraQ4p9hh1AAAAAElFTkSuQmCC"

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 620 */,
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(682),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  "data-v-1d1b8b92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  "data-v-05ec7497",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  "data-v-79b9c9e5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(673),
  /* scopeId */
  "data-v-b585b06a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(675),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  "data-v-0383d5ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(679),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(663),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(681),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(665),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(674),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(662),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(680),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-inverse navbar-fixed-top z-depth-1 b-0 new-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand hidden-xs",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(619)
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand visible-xs",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(618)
    }
  })])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: {
      active: _vm.context === 'patient'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Patient")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.context === 'practice'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Practice")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.context === 'academic'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Academic")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-right nav-xs"
  }, [_c('router-link', {
    staticClass: "btn btn-primary navbar-btn",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary navbar-btn m-l",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Signup")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container white",
    staticStyle: {
      "padding": "4%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-bottom": "3%"
    }
  }, [_c('h2', [_vm._v("LogBox Practice features")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-users"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Demographics\n        "), _c('br'), _vm._v("Sharing\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-book-medical"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("Clinical Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-paste"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Customisable clinical\n        "), _c('br'), _vm._v("templates\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-notes-medical"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Patient\n        "), _c('br'), _vm._v("Questionnaires/\n        "), _c('br'), _vm._v("PROMS\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-credit-card"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Medical Billing\n        "), _c('br'), _vm._v("system integration\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-file-upload"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Document\n        "), _c('br'), _vm._v("management and\n        "), _c('br'), _vm._v("Multimedia Storage\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-file-contract"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("Consent to practice")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-comment"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("Messaging Module")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-clinic-medical"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Pre-admissions\n        "), _c('br'), _vm._v("with integration to\n        "), _c('br'), _vm._v("Hospitals\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-file-medical-alt"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Theatre Lists and\n        "), _c('br'), _vm._v("Waiting Lists\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-server"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Database creation and\n        "), _c('br'), _vm._v("management\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-chart-line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("Reports and analytics")])])])])
}]}

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "packages-landing"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section bg-primary pricing-plans"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pricing-box z-depth-2"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "pricing-action"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("30 Day Free Trial")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pricing-box z-depth-2"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "pricing-action"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("30 Day Free Trial")])], 1)])]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "row text-center m-t-lg",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("\n        Please note all packages are subject to "), _c('a', {
    staticStyle: {
      "color": "white",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v("Terms and Conditions")])])])]), _vm._v(" "), _c('section', {}, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', {}, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', {}, [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', {}, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Learn More")])], 1)])])])]), _vm._v(" "), _c('ud-terms-modal', {
    attrs: {
      "open": _vm.modalOpen
    },
    on: {
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 white text-center text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0"
  }, [_vm._v("Find a solution that works for your practice")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("From only R119 per month, you can move your practice into the digital age. Join the LogBox community today.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-title"
  }, [_c('h3', [_vm._v("Single Practice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-price"
  }, [_c('span', {
    staticClass: "price-unit"
  }, [_vm._v("R")]), _vm._v("119"), _c('span', {
    staticClass: "price-tenure"
  }, [_vm._v("/month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-features"
  }, [_c('ul', [_c('li', [_vm._v("Fewer than 10 users.")]), _vm._v(" "), _c('li', [_vm._v("For every additional user, R10/month per user.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-title"
  }, [_c('h3', [_vm._v("Integrated Billing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-price"
  }, [_c('span', {
    staticClass: "price-unit"
  }, [_vm._v("R")]), _vm._v("250"), _c('span', {
    staticClass: "price-tenure"
  }, [_vm._v("/month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-features",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "12px"
    }
  }, [_c('ul', [_c('li', [_vm._v("Integrated with your current billing software")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pricing-box z-depth-2"
  }, [_c('div', {
    staticClass: "pricing-title"
  }, [_c('h3', [_vm._v("Group Practice")])]), _vm._v(" "), _c('div', {
    staticClass: "pricing-price"
  }, [_c('img', {
    staticClass: "group-practice-icon",
    attrs: {
      "src": __webpack_require__(600)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pricing-features",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('ul', [_c('li', [_vm._v("Contact us and we'll be in touch.")])])]), _vm._v(" "), _c('div', {
    staticClass: "pricing-action"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "href": "mailto:contact@logbox.co.za"
    }
  }, [_vm._v("Contact Us")])])])])
}]}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('div', {
    staticClass: "block form-md"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content text-bold text-center h4"
  }, [_vm._v("\n      Please select the product you would like to sign-up for:\n    ")]), _vm._v(" "), _c('context-selector'), _vm._v(" "), _c('keep-alive', [_c(_vm.currentForm, {
    tag: "component"
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(69)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Signup")])])])
}]}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 pointer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "id": _vm.id,
      "disabled": _vm.loading
    }
  }, [(!_vm.loading) ? _c('span', [_vm._t("default", [_vm._v("Submit")])], 2) : _c('span', [_c('i', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])])])
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patient-landing"
  }, [_c('video-modal', {
    attrs: {
      "open": _vm.videoModalOpen
    },
    on: {
      "close": _vm.closeModal
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 white text-center text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0"
  }, [_vm._v("Tired of filling out the same frustrating forms over and over again?")]), _vm._v(" "), _c('div', {
    staticClass: "m-y"
  }, [_c('a', {
    attrs: {
      "id": "openVideoModal"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(598)
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-lg"
  }, [_c('app-links', {
    attrs: {
      "appLinks": _vm.links
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content text-center"
  }, [_c('h2', {
    staticClass: "m-t-0"
  }, [_vm._v("Patients")]), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign up for free")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content text-center"
  }, [_c('h2', {
    staticClass: "m-t-0"
  }, [_vm._v("Healthcare Professionals")]), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.navAndSetContext('practice')
      }
    }
  }, [_vm._v("Practice")]), _vm._v(" "), _c('span', [_vm._v(" | ")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.navAndSetContext('academic')
      }
    }
  }, [_vm._v("Academic")])])])])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(593)
    }
  }), _vm._v(" "), _c('h2', [_vm._v("No More"), _c('br'), _vm._v("Paper Forms")]), _vm._v(" "), _c('p', [_vm._v("Complete electronically before you arrive")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(594)
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Capture Your"), _c('br'), _vm._v("Details Once")]), _vm._v(" "), _c('p', [_vm._v("And you’ll never need to do it again")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(595)
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Your Information Is"), _c('br'), _vm._v("Secure")]), _vm._v(" "), _c('p', [_vm._v("You choose who has access to your information")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": __webpack_require__(599)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {}, [_vm._v("Patient Benefits")]), _vm._v(" "), _c('p', {
    staticClass: "lead m-b-lg"
  }, [_vm._v("Frustrated with filling out the same medical forms over and over again? Simplify your medical life with LogBox.")]), _vm._v(" "), _c('ul', {
    staticClass: "feature-list fa-ul"
  }, [_c('li', {
    staticClass: "hidden"
  }, [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Stop filling out the same medical forms over and over again. ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Free for patients. ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Keep your information secure on a mobile app or website. ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Share your information with any healthcare professional you choose.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("LogBox works regardless of your medical aid. ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Stay in control of your information, you decide who sees it and when.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa-li fa fa-check"
  }), _vm._v("Your information is secured according to the highest international standards.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section bg-primary"
  }, [_vm._m(1)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign Up Now")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Learn More")])], 1)])])])])
}]}

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container medi-mass-frame medi-mass-top"
  }, [_vm._m(0), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('section', {
    staticClass: "section-5"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "name": "contactMeForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendContactRequest($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    staticClass: "col-xs-3",
    attrs: {
      "name": "name",
      "label": "First Name",
      "validation": _vm.$v.contactMeCriteria.name
    },
    model: {
      value: (_vm.contactMeCriteria.name),
      callback: function($$v) {
        _vm.$set(_vm.contactMeCriteria, "name", $$v)
      },
      expression: "contactMeCriteria.name"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-3",
    attrs: {
      "name": "lastname",
      "label": "Last Name",
      "validation": _vm.$v.contactMeCriteria.lastName
    },
    model: {
      value: (_vm.contactMeCriteria.lastName),
      callback: function($$v) {
        _vm.$set(_vm.contactMeCriteria, "lastName", $$v)
      },
      expression: "contactMeCriteria.lastName"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-3",
    attrs: {
      "name": "email",
      "label": "Email",
      "validation": _vm.$v.contactMeCriteria.email
    },
    model: {
      value: (_vm.contactMeCriteria.email),
      callback: function($$v) {
        _vm.$set(_vm.contactMeCriteria, "email", $$v)
      },
      expression: "contactMeCriteria.email"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-3",
    attrs: {
      "name": "phone",
      "label": "Phone no.",
      "validation": _vm.$v.contactMeCriteria.phoneNumber
    },
    model: {
      value: (_vm.contactMeCriteria.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.contactMeCriteria, "phoneNumber", $$v)
      },
      expression: "contactMeCriteria.phoneNumber"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('button', {
    staticClass: "form-control form-btn btn-danger col-xs-12",
    attrs: {
      "type": "submit",
      "id": "contactMeSubmit",
      "disabled": _vm.loading || _vm.contactRequestSent
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.contactMeButtonTitle) + "\n                  ")]) : _c('span', [_c('i', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://logbox.co.za/#/providers"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(614),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(616)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 text-center line-seperator"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(615),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("LogBox is an easy to use mobile and web app which allows your patients to capture their personal information once and share it electronically with your practice.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h2', [_vm._v("LogBox is integrated with Elixir ")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n            You don't have to worry about retyping patient information into your billing system. LogBox is integrated with Elixir so accurate information will flow from LogBox to invoicing in one easy click. It's that simple.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": __webpack_require__(612),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-2"
  }, [_vm._m(1)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("Send appointment details ")]), _vm._v("via SMS or Email")]), _vm._v(" "), _c('li', [_vm._v("Patients "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("connect to your practice")]), _vm._v(" via the "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("website")]), _vm._v(" or mobile "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("app")])]), _vm._v(" "), _c('li', [_vm._v("Don't struggle to read bad handwriting, let the "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("patient fill in their information")]), _vm._v(" for you")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("Practice-specific Terms and Conditions ")]), _vm._v(" are sent to patients "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("electronically")])]), _vm._v(" "), _c('li', [_vm._v("Create your own "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("customised questionnaires")]), _vm._v(" using the LogBox form creator")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("Reduce bad debt")]), _vm._v(" with "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("accurate")]), _vm._v(" patient information ")]), _vm._v(" "), _c('li', [_vm._v("Receive "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("live updates")]), _vm._v(" if patient details change")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("POPI compliant")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-3"
  }, [_vm._m(3)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', [_vm._v("Patients are frustrated with filling in the same forms over and over again at different healthcare professionals.")]), _vm._v(" "), _c('h1', [_vm._v("Join the LogBox community and move your practice into the digital age. ")]), _vm._v(" "), _c('h1', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("From LogBox to Elixir in seconds")]), _vm._v(" - you will never want to transcribe a paper form again!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-4"
  }, [_vm._m(5)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("Contact")]), _vm._v(" LogBox")]), _vm._v(" "), _c('h2', [_vm._v("We know you're busy, so let us help you. Put your contact details in the fields below and we'll get back to you with all the information you need.\n\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_vm._v("Prefer to contact us? Just send an email on "), _c('a', {
    attrs: {
      "href": "mailto:contact@logbox.co.za"
    }
  }, [_vm._v("contact@logbox.co.za")]), _vm._v(" or call us on "), _c('a', {
    attrs: {
      "href": "tel:+27822627238"
    }
  }, [_vm._v("082 262 7238")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://logbox.co.za/#/providers"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(613),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "open": _vm.open,
      "size": "lg"
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Search for HOD")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "text-center col-md-4 col-md-offset-4 padding-bottom-20"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw fa-5x"
  })]) : (!_vm.loading && _vm.hods.length) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-xs-8"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-info-sign"
  }), _vm._v(" Search for your HOD.\n        ")]), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-4",
    attrs: {
      "name": "filterText",
      "label": "Search"
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  })], 1), _vm._v(" "), (_vm.filteredHods.length) ? _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("First Name")]), _vm._v(" "), _c('td', [_vm._v("Last Name")]), _vm._v(" "), _c('td', [_vm._v("Training Institution")]), _vm._v(" "), _c('td', [_vm._v("Speciality")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredHods), function(hod) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(hod.user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hod.user.surname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hod.trainingInstitution))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hod.speciality))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      on: {
        "click": function($event) {
          return _vm.select(hod)
        }
      }
    }, [_vm._v("Select")])])])
  }), 0)]) : _c('p', {
    staticClass: "text-center padding-bottom-20"
  }, [_vm._v("\n        No HOD's found\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n        Can't find the HOD you are looking for? Invite them to join.\n      ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.invite($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    staticClass: "col-xs-6",
    attrs: {
      "name": "hodEmail",
      "label": "Email Address",
      "validation": _vm.$v.hodInvite.emailAddress
    },
    model: {
      value: (_vm.hodInvite.emailAddress),
      callback: function($$v) {
        _vm.$set(_vm.hodInvite, "emailAddress", $$v)
      },
      expression: "hodInvite.emailAddress"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-6",
    attrs: {
      "name": "hodName",
      "label": "Name",
      "validation": _vm.$v.hodInvite.name
    },
    model: {
      value: (_vm.hodInvite.name),
      callback: function($$v) {
        _vm.$set(_vm.hodInvite, "name", $$v)
      },
      expression: "hodInvite.name"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Invite")])])])])])
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', {
    staticClass: "m-t-0"
  }, [_vm._v("Trusted & Used By")])])]), _vm._v(" "), _c('div', {
    staticClass: "row logos clearfix"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(603)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(608)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(602)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row logos clearfix"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(607)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(606)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(601)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row logos clearfix"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(610)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(609)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(605)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row logos clearfix"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(604)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-lg"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3 text-center"
  }, [_c('p', [_vm._v("LogBox integrates with many platforms and billing systems. If you are a software provider in the medical field, please contact us to find out how we can partner together.")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-0"
  }, [_c('u', [_c('b', [_c('a', {
    attrs: {
      "href": "mailto:partner@logbox.co.za"
    }
  }, [_vm._v("Partner with us")])])])])])])])
}]}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 form-group",
    class: {
      'has-error': this.validation && this.validation.$error
    }
  }, [_c('div', {
    staticClass: "input-group username-input has-feedback"
  }, [_c('float-label', {
    attrs: {
      "label": _vm.required ? _vm.label + '*' : _vm.label,
      "for": _vm.name,
      "fixed": _vm.type === 'date'
    }
  }, [(_vm.type === 'date') ? _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "date",
      "pattern": "\\d{4}-\\d{2}-\\d{2}",
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.required ? _vm.label + '*' : _vm.label,
      "min": _vm.minDate,
      "max": _vm.maxDate
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": _vm.blur
    }
  }) : _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.required ? _vm.label + '*' : _vm.label
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": _vm.blur
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "glyphicon ",
    class: _vm.displayIcons(_vm.name)
  })])], 1), _vm._v(" "), (_vm.validation && _vm.validation.$error) ? _c('div', {
    staticClass: "help-block small",
    attrs: {
      "role": "alert"
    }
  }, [(_vm.requiredError) ? _c('span', [_vm._v("The field is required")]) : (!_vm.validation.maxLength && _vm.validation.$params.maxLength) ? _c('span', [_vm._v("\n          Maximum length is " + _vm._s(_vm.validation.$params.maxLength.max) + "\n        ")]) : (!_vm.validation.minLength && _vm.validation.$params.minLength) ? _c('span', [_vm._v("\n          Minimum length is " + _vm._s(_vm.validation.$params.minLength.min) + "\n        ")]) : (_vm.validation.dateFormat === false) ? _c('span', [_vm._v("The date field must be in a valid format")]) : (!_vm.validation.dateBetween && _vm.validation.$params.dateBetween) ? _c('span', [_vm._v("\n            Date must be between " + _vm._s(_vm.validation.$params.dateBetween.min) + " and\n          " + _vm._s(_vm.validation.$params.dateBetween.max) + "\n        ")]) : (_vm.validation.$invalid) ? _c('span', [_vm._v("The " + _vm._s(_vm.label.toLowerCase()) + " field is invalid.")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.open) ? _c('div', {
    key: "modal",
    class: _vm.modalClass,
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    class: ['modal-dialog', 'modal-' + _vm.size]
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(_vm.slotExists('header')) ? _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.slotExists('footer')) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.open) ? _c('div', {
    key: "modal-backdrop",
    class: _vm.modalBackdropClass
  }) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('form', {
    staticClass: "block form-sm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestRemoval()
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "container-fluid spinner-container"
  }, [_vm._m(1)]) : (_vm.validToken) ? _c('div', {
    staticClass: "content text-bold h5",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v("Please take note of the following process applicable to the deletion of your profile:")]), _vm._v(" "), _c('p', [_vm._v("The HPCSA guidelines states that “Health records should be stored for a period of not less than six (6) years as from the date they became dormant”.")]), _vm._v(" "), _c('p', [_vm._v("On submission of this form, your user account will be removed and your personal information will be ‘archived’ making it inaccessible via the LogBox\n        system and unsubscribing from all email communication to your email address")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('submit-button', {
    attrs: {
      "loading": _vm.loadingRequest
    }
  }, [_vm._v("Submit Request")])], 1) : _c('div', {
    staticClass: "content h5"
  }, [_vm._v("\n      PLEASE NOTE:"), _c('br'), _c('br'), _vm._v("\n      Requests for the removal of patient account details can be done via the "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics"
    }
  }, [_vm._v("LogBox Patient application")]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n      Please download the application from the "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics"
    }
  }, [_vm._v("Google play")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/za/app/logbox-patient/id1101708807"
    }
  }, [_vm._v("Apple store")]), _vm._v(" and submit a request using the account settings."), _c('br'), _c('br')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(69)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Delete your profile")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 primary"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate slow-large-refresh-animate"
  })])])
}]}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-view"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-xs-12",
    class: {
      'has-error': this.validation && this.validation.$error
    }
  }, [_c('div', {
    staticClass: "has-feedback"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    ref: "select",
    staticClass: "form-control",
    attrs: {
      "id": 'select' + _vm.name,
      "disabled": _vm.loading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateValue],
      "blur": _vm.blur
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "id": "optionDefault"
    },
    domProps: {
      "value": undefined
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._l((_vm.options), function(option, index) {
    return _c('option', {
      attrs: {
        "id": 'option' + index
      },
      domProps: {
        "value": option
      }
    }, [_vm._v("\n        " + _vm._s(option.name) + "\n      ")])
  })], 2), _vm._v(" "), (_vm.loading) ? _c('span', {
    staticClass: "form-control-feedback padding-right-15"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
  })]) : _vm._e(), _vm._v(" "), (_vm.required) ? _c('span', {
    staticClass: "glyphicon glyphicon-asterisk form-control-feedback padding-right-15",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.required) ? _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(required)")]) : _vm._e()]), _vm._v(" "), (!_vm.loading && _vm.validation && _vm.validation.$error) ? _c('div', {
    staticClass: "help-block small",
    attrs: {
      "role": "alert"
    }
  }, [(_vm.requiredError) ? _c('span', [_vm._v("The field is required")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('form', {
    staticClass: "block form-sm",
    attrs: {
      "name": "forgotPasswordForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestPasswordReset()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content text-bold text-center h4"
  }, [_vm._v("\n      Please select the product you would like to reset password for:\n    ")]), _vm._v(" "), _c('context-selector'), _vm._v(" "), (!_vm.requestComplete) ? _c('div', [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.context === 'patient') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Cellphone or email address",
      "validation": _vm.$v.username
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.context === 'practice') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Username",
      "validation": _vm.$v.username
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.context === 'academic') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Email address",
      "validation": _vm.$v.username
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col-xs-12 pointer text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "request-password-reset-submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Reset Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.requestComplete) ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n        If a user with this\n        "), (_vm.context === 'patient') ? _c('span', [_vm._v("cellphone or email address")]) : _vm._e(), _vm._v(" "), (_vm.context === 'practice') ? _c('span', [_vm._v("Username")]) : _vm._e(), _vm._v(" "), (_vm.context === 'academic') ? _c('span', [_vm._v("email address")]) : _vm._e(), _vm._v("\n        exists, then a message will be sent to their registered cell phone or email address with password reset instructions\n      ")])]) : _vm._e()], 1), _vm._v(" "), (_vm.otpAvailable) ? _c('div', [_c('form', {
    staticClass: "block form-sm",
    attrs: {
      "name": "otpSubmitForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendPasswordResetWithOTP()
      }
    }
  }, [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("You can also enter the OTP we have sent to your cellphone to reset your password.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "otp",
      "label": "One Time Pin"
    },
    model: {
      value: (_vm.otpValue),
      callback: function($$v) {
        _vm.otpValue = $$v
      },
      expression: "otpValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "password",
      "label": "Enter New Password",
      "validation": _vm.$v.password
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm New Password",
      "validation": _vm.$v.confirmPassword
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col-xs-12 pointer text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "perform-password-reset-submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(69)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Forgotten Password")])])])
}]}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "username",
      "label": "E-mail Address",
      "validation": _vm.$v.user.username
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "password",
      "label": "Password",
      "validation": _vm.$v.user.password
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "validation": _vm.$v.confirmPassword
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    staticClass: "col-xs-6",
    attrs: {
      "name": "name",
      "label": "First Name",
      "validation": _vm.$v.user.name
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-6",
    attrs: {
      "name": "surname",
      "label": "Last Name",
      "validation": _vm.$v.user.surname
    },
    model: {
      value: (_vm.user.surname),
      callback: function($$v) {
        _vm.$set(_vm.user, "surname", $$v)
      },
      expression: "user.surname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "cellularNumber",
      "label": "Cellular Number",
      "validation": _vm.$v.user.cellPhoneNumber
    },
    model: {
      value: (_vm.user.cellPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "cellPhoneNumber", $$v)
      },
      expression: "user.cellPhoneNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-switch', {
    attrs: {
      "name": "identityType",
      "options": _vm.identityTypes
    },
    model: {
      value: (_vm.user.identityType),
      callback: function($$v) {
        _vm.$set(_vm.user, "identityType", $$v)
      },
      expression: "user.identityType"
    }
  })], 1)]), _vm._v(" "), (_vm.user.identityType === 'IDDOC') ? _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "identityNumber",
      "label": "Identity Number",
      "validation": _vm.$v.user.idNumber
    },
    model: {
      value: (_vm.user.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "idNumber", $$v)
      },
      expression: "user.idNumber"
    }
  })], 1)]) : (_vm.user.identityType === 'PASSPORT') ? _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "passportNumber",
      "label": "Passport Number",
      "validation": _vm.$v.user.passportNumber
    },
    model: {
      value: (_vm.user.passportNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "passportNumber", $$v)
      },
      expression: "user.passportNumber"
    }
  }), _vm._v(" "), _c('input-select', {
    attrs: {
      "name": "passportCountry",
      "label": "Passport Country",
      "options": _vm.countries,
      "validation": _vm.$v.passportCountry,
      "loading": _vm.loadingCountries
    },
    model: {
      value: (_vm.passportCountry),
      callback: function($$v) {
        _vm.passportCountry = $$v
      },
      expression: "passportCountry"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "discipline",
      "label": "Select Discipline",
      "options": _vm.disciplines,
      "validation": _vm.$v.discipline,
      "loading": _vm.loadingDisciplines
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadSpecialities($event)
      }
    },
    model: {
      value: (_vm.discipline),
      callback: function($$v) {
        _vm.discipline = $$v
      },
      expression: "discipline"
    }
  })], 1), _vm._v(" "), (_vm.discipline) ? _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "speciality",
      "label": "Select Speciality",
      "options": _vm.specialities,
      "validation": _vm.$v.speciality,
      "loading": _vm.loadingSpecialities
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadGrades($event)
      }
    },
    model: {
      value: (_vm.speciality),
      callback: function($$v) {
        _vm.speciality = $$v
      },
      expression: "speciality"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.speciality) ? _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "grade",
      "label": "Select Speciality Grade",
      "options": _vm.grades,
      "validation": _vm.$v.specialityGrade,
      "loading": _vm.loadingGrades
    },
    model: {
      value: (_vm.specialityGrade),
      callback: function($$v) {
        _vm.specialityGrade = $$v
      },
      expression: "specialityGrade"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "hpcsaNumber",
      "label": "HPCSA Number",
      "validation": _vm.$v.user.hpcsaNumber
    },
    model: {
      value: (_vm.user.hpcsaNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "hpcsaNumber", $$v)
      },
      expression: "user.hpcsaNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "practiceNumber",
      "label": "Practice Number",
      "validation": _vm.$v.user.prNumber
    },
    model: {
      value: (_vm.user.prNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "prNumber", $$v)
      },
      expression: "user.prNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "academicSector",
      "label": "Are you in the Academic Sector",
      "options": _vm.academicSectorOptions,
      "validation": _vm.$v.academicSector
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadRolesAndInstitutions($event)
      }
    },
    model: {
      value: (_vm.academicSector),
      callback: function($$v) {
        _vm.academicSector = $$v
      },
      expression: "academicSector"
    }
  })], 1), _vm._v(" "), (_vm.inAcademicSector) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "institution",
      "label": "Select Training Institution",
      "options": _vm.institutions,
      "validation": _vm.$v.trainingInstitution,
      "loading": _vm.loadingInstitutions
    },
    model: {
      value: (_vm.trainingInstitution),
      callback: function($$v) {
        _vm.trainingInstitution = $$v
      },
      expression: "trainingInstitution"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "role",
      "label": "Select Role",
      "options": _vm.roles,
      "validation": _vm.$v.role,
      "loading": _vm.loadingRoles
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  })], 1), _vm._v(" "), (_vm.traineeSignup) ? [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "traineePostNumber",
      "label": "Trainee Post Number",
      "validation": _vm.$v.trainee.traineePostNumber
    },
    model: {
      value: (_vm.trainee.traineePostNumber),
      callback: function($$v) {
        _vm.$set(_vm.trainee, "traineePostNumber", $$v)
      },
      expression: "trainee.traineePostNumber"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.displayRegistarAppointmentField) ? [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "appointmentDate",
      "label": "Date of appointment as registrar",
      "type": "date",
      "min-date": _vm.registrarAppointmentMinDate,
      "max-date": _vm.registrarAppointmentMaxDate,
      "validation": _vm.$v.trainee.registrarAppointmentDate
    },
    model: {
      value: (_vm.trainee.registrarAppointmentDate),
      callback: function($$v) {
        _vm.$set(_vm.trainee, "registrarAppointmentDate", $$v)
      },
      expression: "trainee.registrarAppointmentDate"
    }
  })], 1)] : (_vm.role && _vm.role.name === 'SUPERVISOR') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "clinicalUnit",
      "label": "Clinical Unit",
      "validation": _vm.$v.supervisor.clinicalUnit
    },
    model: {
      value: (_vm.supervisor.clinicalUnit),
      callback: function($$v) {
        _vm.$set(_vm.supervisor, "clinicalUnit", $$v)
      },
      expression: "supervisor.clinicalUnit"
    }
  })], 1), _vm._v(" "), (_vm.trainingInstitution && _vm.speciality) ? _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "hod",
      "label": "Head of Department",
      "validation": _vm.$v.hod
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openHodSearchModal($event)
      }
    },
    model: {
      value: (_vm.hodFullName),
      callback: function($$v) {
        _vm.hodFullName = $$v
      },
      expression: "hodFullName"
    }
  }), _vm._v(" "), _c('hod-search-modal', {
    attrs: {
      "open": _vm.hodSearchModalOpen,
      "speciality-id": _vm.speciality.id,
      "training-institute-id": _vm.trainingInstitution.id
    },
    on: {
      "close": _vm.closeHodSearchModal
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.displayHodWarning) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e()]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group col-sm-offset-3"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "terms",
      "required": ""
    }
  }), _vm._v(" I have read and accept the\n          "), _c('a', {
    staticClass: "highlight",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openTermsModal($event)
      }
    }
  }, [_vm._v("Terms and Conditions")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "signUpSubmit",
      "loading": _vm.loading
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _c('academic-terms-modal', {
    attrs: {
      "open": _vm.termsModalOpen,
      "id": "openTermsModal"
    },
    on: {
      "close": _vm.closeTermsModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n              The email entered belongs to an HOD in a different training institution or speciality. Click register if you are sure you want to continue sending them the access request.\n            ")])])
}]}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('form', {
    staticClass: "block form-sm",
    attrs: {
      "name": "forgotUsernameForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestUsernameReminder()
      }
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.requestComplete) ? _c('div', {
    staticClass: "subheader"
  }, [_c('p', [_vm._v("Please enter your email address below")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.requestComplete) ? _c('div', [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "email",
      "label": "Email Address",
      "validation": _vm.$v.emailAddress
    },
    model: {
      value: (_vm.emailAddress),
      callback: function($$v) {
        _vm.emailAddress = $$v
      },
      expression: "emailAddress"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col-xs-12 pointer text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "request-username-reminder-submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Request Reminder")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.requestComplete) ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("If a user with this email address exists, then an email will be sent to their registered email address with a username\n        reminder")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(69)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Forgotten Username")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "glyphicon glyphicon-asterisk"
  }), _vm._v(" indicates a required field")])
}]}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('form', {
    staticClass: "block form-md",
    attrs: {
      "autocomplete": "off",
      "name": "loginForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content text-bold text-center h4"
  }, [_vm._v("\n      Select a product:\n    ")]), _vm._v(" "), _c('context-selector'), _vm._v(" "), (_vm.error.message) ? _c('error-display', [(_vm.error.type === 'ACCOUNT_LOCKED') ? _c('div', [_vm._v("\n        Your account is locked. Please use the\n        "), _c('router-link', {
    attrs: {
      "to": "ForgotPassword"
    }
  }, [_vm._v("forgot password")]), _vm._v("\n        function to reset your account and password.\n      ")], 1) : _c('div', [_vm._v("\n        " + _vm._s(_vm.error.message) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.context) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.context === 'patient') ? _c('under-construction-display', {
    attrs: {
      "appLinks": _vm.links
    }
  }) : _vm._e(), _vm._v(" "), (_vm.context === 'practice') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Username",
      "validation": _vm.$v.credentials.username
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.context === 'academic') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Email address",
      "validation": _vm.$v.credentials.username
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.context !== 'patient') ? _c('input-password', {
    attrs: {
      "name": "password",
      "label": "Password",
      "validation": _vm.$v.credentials.password
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.context && (_vm.context !== 'patient')) ? _c('div', {
    staticClass: "footer"
  }, [_c('submit-button', {
    attrs: {
      "id": "login-submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [_c('p', [_vm._v("Trouble signing in? "), _c('router-link', {
    attrs: {
      "to": "ForgotPassword"
    }
  }, [_vm._v("Click here")])], 1)])], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(69)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Login")])])])
}]}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "practice-landing"
  }, [_c('video-modal', {
    attrs: {
      "open": _vm.videoModalOpen
    },
    on: {
      "close": _vm.closeModal
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section intro practice-section-1"
  }, [_c('div', {
    staticClass: "container practice-cover-div",
    attrs: {
      "id": "p-c-div"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0"
  }, [_vm._v("Health Care Professional premier clinical solution")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn practice-signup-button",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign up")])], 1)])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_c('b', [_vm._v("LogBox Practice uses the latest "), _c('br'), _vm._v("technology to conveniently capture and "), _c('br'), _vm._v("store patient data.\n                        "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "practice-lead-text-2"
  }, [_vm._v("Improve patient care, record-keeping, case management and practice efficiency.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('span', {
    staticClass: "section-feature-icons-two"
  }, [_c('i', {
    staticClass: "fas fa-hands"
  })]), _vm._v(" "), _c('h3', [_vm._v("Patient Centric")]), _vm._v(" "), _c('p', [_vm._v("Enterprise-grade demographics capture\n                        "), _c('br'), _vm._v(" and patient onboarding")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('span', {
    staticClass: "section-feature-icons-two"
  }, [_c('i', {
    staticClass: "fas fa-user-friends"
  })]), _vm._v(" "), _c('h3', [_vm._v("Clinical Collaboration")]), _vm._v(" "), _c('p', [_vm._v("Real-time clinical data sharing between\n                        "), _c('br'), _vm._v(" multidisciplinary teams")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('span', {
    staticClass: "section-feature-icons-two"
  }, [_c('i', {
    staticClass: "fas fa-cloud-upload-alt"
  })]), _vm._v(" "), _c('h3', [_vm._v("Cloud Based")]), _vm._v(" "), _c('p', [_vm._v("High-performance web and mobile\n                        "), _c('br'), _vm._v(" applications\n                    ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section practice-section-2"
  }, [_vm._m(1)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section practice-section-3 section-feature-background"
  }, [_c('PracticeFeatures')], 1)
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 p-b-lg"
  }, [_c('ul', {
    staticClass: "feature-list fa-ul"
  }, [_c('li', {
    staticClass: "practice-benefits-title"
  }, [_c('h2', {}, [_vm._v("LogBox benefits")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Avoid repetitive tasks and become\n                                "), _c('br'), _vm._v("digitally efficient")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Profile completeness enforced by\n                                "), _c('br'), _vm._v("the system")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Create seamless clinical workflows")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Accuracy of Data entry")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Save on printing costs")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("POPI compliance")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section practice-section-4 practice-benefit-section"
  }, [_vm._m(4)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section practice-section-5 section-feature-background white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Learn More")]), _vm._v(" "), _c('p', [_vm._v("Your first 30 patients are free, then the monthly fee applies")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn practice-price-plan-btn",
    attrs: {
      "to": "/priceplans"
    }
  }, [_vm._v("PLANS & PRICING")])], 1)])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', {}, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn practice-price-plan-btn",
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', {}, [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#14D3AB"
    },
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign Up Now")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', {}, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn practice-price-plan-btn",
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Learn More")])], 1)])])])])
}]}

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete col-12"
  }, [_c('div', {
    staticClass: "col-12 mt-4"
  }, [_c('div', {
    staticClass: "input-group-append"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "search",
      "type": "search",
      "placeholder": "Practice name",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "focus": _vm.onFocus,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }, _vm.autoComplete],
      "blur": _vm.closeSuggestions
    }
  })]), _vm._v(" "), (_vm.showSuggestion) ? _c('ul', {
    staticClass: "text-left list-group autocomplete-list"
  }, _vm._l((_vm.suggestions), function(s) {
    return _c('li', {
      key: s.id,
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.chosen(s)
        },
        "mousedown": function($event) {
          _vm.suggestionFocus = true
        }
      }
    }, [(s.logoImage) ? _c('img', {
      staticClass: "autocomplete-image",
      attrs: {
        "src": ("data:image/png;base64," + (s.logoImage))
      }
    }) : _c('img', {
      staticClass: "autocomplete-image",
      attrs: {
        "src": __webpack_require__(227)
      }
    }), _vm._v("\n         " + _vm._s(s.name))])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subheader clearfix"
  }, [_c('span', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.updateContext('patient')
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    class: _vm.patientContext,
    attrs: {
      "src": __webpack_require__(584)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.updateContext('practice')
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    class: _vm.practiceContext,
    attrs: {
      "src": __webpack_require__(585)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.updateContext('academic')
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    class: _vm.academicContext,
    attrs: {
      "src": __webpack_require__(582)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b-lg",
    staticStyle: {
      "color": "#575757"
    }
  }, [_vm._v("LogBox for patients")]), _vm._v(" "), _c('div', {
    staticClass: "m-b m-t-3"
  }, [_c('h5', [_vm._v("\n                    Complete the forms online now.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg ",
    attrs: {
      "type": "button",
      "id": "openKioskLink"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("Search for your doctor")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Complete and share your information on the go")]), _vm._v(" "), _c('app-links', {
    attrs: {
      "appLinks": _vm.appLinks
    }
  })], 1)])]), _vm._v(" "), _c('kiosk-modal', {
    attrs: {
      "openModal": _vm.openKioskModal,
      "id": "kioskModal"
    },
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "academic-landing"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('section', {
    staticClass: "section devices m-b-0"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-center tabsAct m-b-lg"
  }, [_c('ul', {
    staticClass: "list-inline text-center",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    class: {
      active: _vm.activeTab === 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 1
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 2
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 3
      }
    }
  }, [_vm._m(7)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.activeTab === 1
    },
    attrs: {
      "role": "tabpanel",
      "id": "android"
    }
  }, [_vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.activeTab === 2
    },
    attrs: {
      "role": "tabpanel",
      "id": "ios"
    }
  }, [_vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.activeTab === 3
    },
    attrs: {
      "role": "tabpanel",
      "id": "pc"
    }
  }, [_vm._m(19), _vm._v(" "), _vm._m(20)])])])]), _vm._v(" "), _vm._m(21)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 white text-center text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0 m-b-lg"
  }, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments")]), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('app-links', {
    attrs: {
      "appLinks": _vm.links
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Approved by the Colleges of Medicine South Africa")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section p-y-md"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h3', {
    staticClass: "m-t-0"
  }, [_vm._v("Supported Specialities")]), _vm._v(" "), _c('div', {
    staticClass: "label-tags text-center m-y-lg"
  }, _vm._l((_vm.specialities), function(speciality, idx) {
    return _c('div', {
      key: idx
    }, [_vm._v("\n              " + _vm._s(speciality) + "\n            ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "m-b-0"
  }, [_vm._v("More Specialities coming soon...")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row m-b-lg"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', [_vm._v("LogBox Academic Benefits")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-left"
  }, [_c('ul', {
    staticClass: "feature-list icon-left"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-university"
  }), _vm._v(" "), _c('h3', [_vm._v("Integrate with your"), _c('br'), _vm._v("academic institution")]), _vm._v(" "), _c('p', [_vm._v("Endorsed by the Colleges of Medicine of South Africa and links directly to your training institution.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('h3', [_vm._v("CV and Academic"), _c('br'), _vm._v("training history")]), _vm._v(" "), _c('p', [_vm._v("Record your academic progress in a well structured format.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('h3', [_vm._v("Sign off your"), _c('br'), _vm._v("rotations electronically")]), _vm._v(" "), _c('p', [_vm._v("Supervisors and Heads of Departments can electronically approve your rotations.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" "), _c('h3', [_vm._v("Absolute"), _c('br'), _vm._v("Privacy")]), _vm._v(" "), _c('p', [_vm._v("Feel secure by setting up either a unique code or setup biometric access.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center hidden-xs"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(617)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-left"
  }, [_c('ul', {
    staticClass: "feature-list icon-left"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" "), _c('h3', [_vm._v("Logbook"), _c('br'), _vm._v("Reports")]), _vm._v(" "), _c('p', [_vm._v("Easily export your de-identified procedure reports to Excel and PDF documents.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-cloud-upload"
  }), _vm._v(" "), _c('h3', [_vm._v("Upload Procedure"), _c('br'), _vm._v("Photos")]), _vm._v(" "), _c('p', [_vm._v("Upload your photos and file them with the relevant procedure.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" "), _c('h3', [_vm._v("Online & Offline"), _c('br'), _vm._v("Access")]), _vm._v(" "), _c('p', [_vm._v("Log your procedures even when you aren't connected to the internet.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-cloud"
  }), _vm._v(" "), _c('h3', [_vm._v("1GB Free"), _c('br'), _vm._v("Cloud Storage")]), _vm._v(" "), _c('p', [_vm._v("Safe and reliable backup that is accessible from anywhere.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section benefits"
  }, [_vm._m(2)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row m-b-l"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', {
    staticClass: "m-t-0 m-b-lg"
  }, [_vm._v("LogBox Academic works on all devices")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "href": "#android",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-android fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "href": "#ios",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-apple fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "href": "#pc",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Secure Access")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Keep your details as well as the details of your patients private by logging in securely.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": __webpack_require__(586)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Procedure Logbook")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Log and review all of your procedures in the list overview section.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": __webpack_require__(587)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Comprehensive Information")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("View a comprehensive detailed overview of your past procedures.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": __webpack_require__(588)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Secure Access")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Keep your details as well as the details of your patients private by logging in securely.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": __webpack_require__(589)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Procedure Logbook")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Log and review all of your procedures in the list overview section.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": __webpack_require__(590)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Comprehensive Information")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("View a comprehensive detailed overview of your past procedures.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": __webpack_require__(591)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Secure Access")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Keep your details as well as the details of your patients private by logging in securely.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Procedure Logbook")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Log and review all of your procedures in the list overview section.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Comprehensive Information")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("View a comprehensive detailed overview of your past procedures.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": __webpack_require__(592)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', {}, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', {}, [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', {}, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign Up Now")])], 1)])])])])
}]}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified new-switch-group"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('label', {
      key: index,
      staticClass: "btn-group new-switch-label pointer",
      class: [_vm.selectedValue === option.value ? 'new-switch-active' : ''],
      attrs: {
        "id": 'opt' + option.value,
        "name": _vm.name
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedValue),
        expression: "selectedValue"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.selectedValue, option.value)
      },
      on: {
        "click": _vm.updateValue,
        "change": function($event) {
          _vm.selectedValue = option.value
        }
      }
    }), _vm._v("\n      " + _vm._s(option.name) + "\n    ")])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfl-has-label"
  }, [_c('label', {
    staticClass: "vfl-label",
    class: _vm.classObject,
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v("\n    " + _vm._s(_vm.floatLabel) + "\n  ")]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(4)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_c('p', {}, [_c('b', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("Plans & Pricing")]), _c('br'), _vm._v("\n                        Sign up for free and only start paying after onboarding the first 30 LogBox patients")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "price-plans-table-header white"
  }, [_c('tr', [_c('th', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("LogBox Core")])]), _vm._v(" "), _c('th', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("LogBox Premium")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', {
    staticClass: "price-plans-table-footer white"
  }, [_c('tr'), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('h4', [_vm._v("R250/ month")])]), _vm._v(" "), _c('td', [_c('h4', [_vm._v("R970/ month")])])]), _vm._v(" "), _c('tr', {
    staticClass: "align-center"
  }, [_c('td'), _vm._v(" "), _c('td', [_c('p', [_vm._v("R2500 once-off practice\n                                                "), _c('br'), _vm._v(" configuration and training fee")])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("R2500 once-off practice\n                                                "), _c('br'), _vm._v(" configuration and training fee")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-pp-discount card-body"
  }, [_vm._v("\n                                   Academic Units (State sector) qualify for 50% Discount\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-pp-discount card-body"
  }, [_vm._v("\n                                    Allied health (Single practice) qualify for 20% Discount\n                                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-landing"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "price-plans-table table table-hover",
    attrs: {
      "id": "pricePlansTable"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.plans), function(feature, index) {
    return _c('tr', {
      key: index,
      staticClass: "price-plans-table-rows"
    }, [_c('td', [_vm._v(_vm._s(feature.name))]), _vm._v(" "), _c('td', [(feature.isCoreActive) ? _c('i', {
      staticClass: "price-plan-icons fas fa-check fa-lg"
    }) : _vm._e()]), _vm._v(" "), _c('td', [(feature.isPremiumActive) ? _c('i', {
      staticClass: "price-plan-icons fas fa-check fa-lg"
    }) : _vm._e()])])
  }), 0), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn practice-pp-signup-btn",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("SIGN UP NOW")])], 1)])])])])])
}]}

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('form', {
    attrs: {
      "name": "signupForm"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [(_vm.role === 'TRAINEE') ? _c('h1', [_vm._v("Signup for LogBox Academic - Email Verification")]) : _vm._e(), _vm._v(" "), (_vm.role === 'HOD') ? _c('h1', [_vm._v("Signup for LogBox Academic - Supervisor Activation")]) : _vm._e()])])]), _vm._v(" "), (_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (_vm.verified) ? _c('div', [_vm._v("Your account has now been activated. Please click the button below to login.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline",
      "float": "right"
    }
  }, [(_vm.verified) ? _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button",
      "id": "login-submit-button",
      "name": "login-submit-button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectLogin()
      }
    }
  }, [_vm._v("\n                  Login\n                ")]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "15px",
      "margin-right": "11px"
    },
    attrs: {
      "src": __webpack_require__(227)
    }
  })])
}]}

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "new-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center text-sm-left"
  }, [_c('h4', [_vm._v("Our Products")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Patient")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Practice")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Academic")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center text-sm-left"
  }, [_c('h4', [_vm._v("Useful Links")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "id": "openPrivacyModal"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('privacy')
      }
    }
  }, [_vm._v("Privacy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "openTermsModal"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('terms')
      }
    }
  }, [_vm._v("Terms and Conditions")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "openPopiModal"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('popi')
      }
    }
  }, [_vm._v("Protection of Personal Information (POPI)")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('popi-modal', {
    attrs: {
      "open": _vm.popiModalOpen
    },
    on: {
      "close": function($event) {
        return _vm.closeModal('popi')
      }
    }
  }), _vm._v(" "), _c('privacy-modal', {
    attrs: {
      "open": _vm.privacyModalOpen
    },
    on: {
      "close": function($event) {
        return _vm.closeModal('privacy')
      }
    }
  }), _vm._v(" "), _c('ud-terms-modal', {
    attrs: {
      "open": _vm.udTermsModalOpen
    },
    on: {
      "close": function($event) {
        return _vm.closeModal('udTerms')
      }
    }
  }), _vm._v(" "), _c('academic-terms-modal', {
    attrs: {
      "open": _vm.academicTermsModalOpen
    },
    on: {
      "close": function($event) {
        return _vm.closeModal('academicTerms')
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 text-center text-sm-left"
  }, [_c('img', {
    staticClass: "img-responsive center-sm-block",
    attrs: {
      "src": __webpack_require__(611)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 text-center text-sm-left"
  }, [_c('h4', [_vm._v("Johannesburg Office")]), _vm._v(" "), _c('p', [_vm._v("Building 12"), _c('br'), _vm._v("\n          Woodmead Estate"), _c('br'), _vm._v("\n          1 Woodmead Drive"), _c('br'), _vm._v("\n          Woodmead")]), _vm._v(" "), _c('h4', [_vm._v("Pretoria Office")]), _vm._v(" "), _c('p', [_vm._v("46 Ingersol Road"), _c('br'), _vm._v("\n          Lynnwood Glen"), _c('br'), _vm._v("\n          Pretoria")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 text-center text-sm-left"
  }, [_c('h4', [_vm._v("Contact Us")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled "
  }, [_c('li', {
    staticClass: "m-b"
  }, [_c('a', {
    staticClass: "h4 m-t-0",
    attrs: {
      "href": "mailto:contact@logbox.co.za"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" contact@logbox.co.za")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "h4 m-b-0",
    attrs: {
      "href": "tel:+27822627238"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" 082 262 7238")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-elephant"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('a', {
    attrs: {
      "href": "http://www.groupelephant.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(583)
    }
  }), _vm._v(" part of the groupelephant.com family")])])])])])
}]}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-gutters",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 form-group",
    class: {
      'has-error': this.validation && this.validation.$error
    }
  }, [_c('div', {
    staticClass: "input-group password-input"
  }, [_c('float-label', {
    attrs: {
      "label": _vm.required ? _vm.label + '*' : _vm.label
    }
  }, [(_vm.passwordNotVisible) ? _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "id": _vm.name,
      "name": "password*",
      "placeholder": _vm.required ? _vm.label + '*' : _vm.label
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": _vm.blur
    }
  }) : _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.required ? _vm.label + '*' : _vm.label
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": _vm.blur
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    on: {
      "click": _vm.showHidePassword
    }
  }, [(_vm.passwordNotVisible) ? _c('i', {
    staticClass: "glyphicon glyphicon-eye-close"
  }) : _c('i', {
    staticClass: "glyphicon glyphicon-eye-open"
  })])], 1), _vm._v(" "), (_vm.validation && _vm.validation.$error) ? _c('div', {
    staticClass: "col-xs-12 help-block small",
    attrs: {
      "role": "alert"
    }
  }, [(_vm.requiredError) ? _c('span', [_vm._v("The field is required")]) : (_vm.passwordError) ? _c('span', [_vm._v("Password needs at least 8 characters. Must consist of at least one number character and one alphabet character")]) : (_vm.passwordMatchError) ? _c('span', [_vm._v("The value entered does not match")]) : _c('span', [_vm._v("Please enter a valid value for this field")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "open": _vm.open
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "col-xs-8 col-xs-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Close")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    staticClass: "video",
    attrs: {
      "src": "https://www.youtube.com/embed/B0fIlEU8kQY",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])
}]}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": _vm.appLinks.apple
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(597)
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.appLinks.andriod
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(596)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "open": _vm.openModal
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Find your doctor")])]), _vm._v(" "), _c('div', {
    staticClass: "practice-search-modal-body"
  }, [_c('h4', [_vm._v("Search for the practice that you would like to connect to")]), _vm._v(" "), _c('practice-search', {
    on: {
      "practice": _vm.practice
    }
  })], 1), _vm._v(" "), (_vm.chosenPractice) ? _c('div', {
    staticClass: "text-center alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    You have selected " + _vm._s(_vm._f("upperCase")(_vm.chosenPractice.name)) + ". Would you like to continue?\n  ")]) : _vm._e(), _vm._v(" "), (_vm.errorOccured) ? _c('div', {
    staticClass: "text-center alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Could not load the practice forms. Please contact "), _c('u', [_vm._v("support@logbox.co.za")]), _vm._v(" for assistance.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "float-left col-xs-4 col-xs-offset-1"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-block btn-close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "float-right col-xs-4 col-xs-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "disabled": !_vm.chosenPractice
    },
    on: {
      "click": function($event) {
        return _vm.redirectToKioskSite(_vm.link)
      }
    }
  }, [_vm._v("Continue")])])])])
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    staticClass: "col-md-6",
    attrs: {
      "name": "firstName",
      "label": "First Name",
      "validation": _vm.$v.user.firstname
    },
    model: {
      value: (_vm.user.firstname),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstname", $$v)
      },
      expression: "user.firstname"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-md-6",
    attrs: {
      "name": "lastName",
      "label": "Last Name",
      "validation": _vm.$v.user.lastname
    },
    model: {
      value: (_vm.user.lastname),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastname", $$v)
      },
      expression: "user.lastname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "emailAddress",
      "label": "Email Address",
      "validation": _vm.$v.user.emailAddress
    },
    model: {
      value: (_vm.user.emailAddress),
      callback: function($$v) {
        _vm.$set(_vm.user, "emailAddress", $$v)
      },
      expression: "user.emailAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "cellularAddress",
      "label": "Cellular Number",
      "validation": _vm.$v.user.cellularNumber
    },
    model: {
      value: (_vm.user.cellularNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "cellularNumber", $$v)
      },
      expression: "user.cellularNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_c('h4', {
    staticClass: "padding-bottom-10"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usernameType),
      expression: "usernameType"
    }],
    attrs: {
      "type": "radio",
      "id": "usernameTypeEmail",
      "name": "usernameType",
      "value": "EMAIL"
    },
    domProps: {
      "checked": _vm._q(_vm.usernameType, "EMAIL")
    },
    on: {
      "change": function($event) {
        _vm.usernameType = "EMAIL"
      }
    }
  }), _vm._v("\n          Use Email Address"), (_vm.usernameType === 'EMAIL') ? _c('span', [_vm._v(": " + _vm._s(_vm.user.emailAddress))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usernameType),
      expression: "usernameType"
    }],
    attrs: {
      "type": "radio",
      "id": "usernameTypeCellular",
      "name": "usernameType",
      "value": "CELLULAR"
    },
    domProps: {
      "checked": _vm._q(_vm.usernameType, "CELLULAR")
    },
    on: {
      "change": function($event) {
        _vm.usernameType = "CELLULAR"
      }
    }
  }), _vm._v("\n          Use Cellular Number"), (_vm.usernameType === 'CELLULAR') ? _c('span', [_vm._v(": " + _vm._s(_vm.user.cellularNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usernameType),
      expression: "usernameType"
    }],
    attrs: {
      "type": "radio",
      "id": "usernameTypeCustom",
      "name": "usernameType",
      "value": "CUSTOM"
    },
    domProps: {
      "checked": _vm._q(_vm.usernameType, "CUSTOM")
    },
    on: {
      "click": _vm.clearUsername,
      "change": function($event) {
        _vm.usernameType = "CUSTOM"
      }
    }
  }), _vm._v("\n          Create your own\n        ")])]), _vm._v(" "), (_vm.usernameType === 'CUSTOM') ? _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "username",
      "label": "Username",
      "validation": _vm.$v.user.username
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "password",
      "label": "Password",
      "validation": _vm.$v.user.password
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "validation": _vm.$v.confirmPassword
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-switch', {
    attrs: {
      "name": "identityType",
      "options": _vm.identityTypes
    },
    model: {
      value: (_vm.user.identityType),
      callback: function($$v) {
        _vm.$set(_vm.user, "identityType", $$v)
      },
      expression: "user.identityType"
    }
  })], 1)]), _vm._v(" "), (_vm.user.identityType === 'IDDOC') ? _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "identityNumber",
      "label": "Identity Number",
      "validation": _vm.$v.user.identityNumber
    },
    model: {
      value: (_vm.user.identityNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "identityNumber", $$v)
      },
      expression: "user.identityNumber"
    }
  })], 1)]) : (_vm.user.identityType === 'PASSPORT') ? _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "passportNumber",
      "label": "Passport Number",
      "validation": _vm.$v.user.passportNumber
    },
    model: {
      value: (_vm.user.passportNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "passportNumber", $$v)
      },
      expression: "user.passportNumber"
    }
  }), _vm._v(" "), _c('input-select', {
    attrs: {
      "name": "passportCountry",
      "label": "Passport Country",
      "options": _vm.countries,
      "validation": _vm.$v.user.passportCountry,
      "loading": _vm.loadingCountries
    },
    model: {
      value: (_vm.user.passportCountry),
      callback: function($$v) {
        _vm.$set(_vm.user, "passportCountry", $$v)
      },
      expression: "user.passportCountry"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.user.type === 'HCP') ? _c('span', [_c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "discipline",
      "label": "Select Discipline",
      "options": _vm.disciplines,
      "validation": _vm.$v.user.hcp.discipline,
      "loading": _vm.loadingDisciplines
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadSpecialities($event)
      }
    },
    model: {
      value: (_vm.user.hcp.discipline),
      callback: function($$v) {
        _vm.$set(_vm.user.hcp, "discipline", $$v)
      },
      expression: "user.hcp.discipline"
    }
  })], 1), _vm._v(" "), (_vm.user.hcp.discipline) ? _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "speciality",
      "label": "Select Speciality",
      "options": _vm.specialities,
      "validation": _vm.$v.user.hcp.speciality,
      "loading": _vm.loadingSpecialities
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadRoles($event)
      }
    },
    model: {
      value: (_vm.user.hcp.speciality),
      callback: function($$v) {
        _vm.$set(_vm.user.hcp, "speciality", $$v)
      },
      expression: "user.hcp.speciality"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.hcp.speciality) ? _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "role",
      "label": "Select Role",
      "options": _vm.roles,
      "validation": _vm.$v.user.hcp.role,
      "loading": _vm.loadingRoles
    },
    model: {
      value: (_vm.user.hcp.role),
      callback: function($$v) {
        _vm.$set(_vm.user.hcp, "role", $$v)
      },
      expression: "user.hcp.role"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "hpcsa",
      "label": "HPCSA Number",
      "validation": _vm.$v.user.hcp.hpcsaNumber
    },
    model: {
      value: (_vm.user.hcp.hpcsaNumber),
      callback: function($$v) {
        _vm.$set(_vm.user.hcp, "hpcsaNumber", $$v)
      },
      expression: "user.hcp.hpcsaNumber"
    }
  })], 1), _vm._v(" "), (!_vm.user.inviteCode) ? _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "practiceNumber",
      "label": "Practice Number",
      "validation": _vm.$v.user.practiceNumber
    },
    model: {
      value: (_vm.user.practiceNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "practiceNumber", $$v)
      },
      expression: "user.practiceNumber"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.inviteCode) ? _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "practicePhone",
      "label": "Practice Phone Number",
      "validation": _vm.$v.user.phone.number
    },
    model: {
      value: (_vm.user.phone.number),
      callback: function($$v) {
        _vm.$set(_vm.user.phone, "number", $$v)
      },
      expression: "user.phone.number"
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group col-sm-offset-3"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "terms",
      "required": ""
    }
  }), _vm._v(" I have read and accept the\n          "), _c('a', {
    staticClass: "highlight",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal($event)
      }
    }
  }, [_vm._v("Terms and Conditions")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "signUpSubmit",
      "loading": _vm.loading
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _c('ud-terms-modal', {
    attrs: {
      "open": _vm.modalOpen,
      "id": "openTermsModal"
    },
    on: {
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('form', {
    staticClass: "block form-sm",
    attrs: {
      "name": "changePasswordForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.performPasswordReset()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "password",
      "label": "Password",
      "validation": _vm.$v.password
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "validation": _vm.$v.confirmPassword
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col-xs-12 pointer text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "perform-password-reset-submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(69)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Change Password")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subheader"
  }, [_c('p', [_vm._v("Please enter your new password below")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "glyphicon glyphicon-asterisk"
  }), _vm._v(" indicates a required field\n      ")])])
}]}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(5)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 white text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0 m-b-lg"
  }, [_vm._v("The LogBox Story")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-a"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-offset-3 text-left"
  }, [_c('h1', {
    staticClass: "m-b-lg"
  }, [_vm._v("In the beginning")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "lead"
  }, [_vm._v("LogBox was founded in 2010 by an orthopaedic surgeon who wanted to change the way things were done. ")]), _vm._v(" "), _c('p', [_vm._v("LogBox simplifies everybody’s life – from the "), _c('a', {
    attrs: {
      "href": "#/patient"
    }
  }, [_vm._v("patient")]), _vm._v(" to the "), _c('a', {
    attrs: {
      "href": "#/practice"
    }
  }, [_vm._v("healthcare professional ")]), _vm._v(" to the "), _c('a', {
    attrs: {
      "href": "#/academic"
    }
  }, [_vm._v("trainee doctor")]), _vm._v(".\n\t\t\t\t\tAdmin is a part of life, but it doesn’t add any value, only plenty of time and frustration. LogBox was designed by doctors who understand the value of people\n\t\t\t\t\tand their time, and who understand the needs of healthcare professionals, the healthcare industry and their patients.")]), _vm._v(" "), _c('p', [_vm._v("LogBox improves the connections between people and healthcare professionals and is part of our commitment to creating user-friendly and intelligent clinical\n\t\t\t\t\t\tsolutions which leverage modern technology to inspire collaboration and transformation. ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-b"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-offset-3 text-left"
  }, [_c('h1', {
    staticClass: "m-b-lg"
  }, [_vm._v("A good start")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Even before its official launch, LogBox was piloted at the Wits Donald Gordon Medical Centre and registered more than 5,000 patients.\n\t\t\t\t\t\tIt was also nominated as a finalist in the MTN Business App of the Year Awards when it was only three months old. ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-c"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-offset-3 text-left"
  }, [_c('h1', {
    staticClass: "m-b-lg"
  }, [_vm._v("Big brother")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "lead"
  }, [_vm._v("EPI-USE is a company founded in South Africa with offices in 22 countries.")]), _vm._v(" "), _c('p', [_vm._v("The company has been building a successful track record in bespoke\n\t\t\t\t\t\t\tsoftware application development since its inception in 1984 and has been involved in a large number of successful, custom software engineering\n\t\t\t\t\t\t\tprojects ever since, spanning industries like Telecommunications, Energy, Insurance, Mining, Oil & Gas, Government, Insurance, Education, and\n\t\t\t\t\t\t\tHealthcare; in both local and international markets. EPI-USE's software application development capability is traded under the 'Advance' brand.")]), _vm._v(" "), _c('p', [_vm._v("More information can be found at "), _c('a', {
    attrs: {
      "href": "http://www.advance.io"
    }
  }, [_vm._v("www.advance.io")]), _vm._v(".")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-d"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-offset-3 text-left"
  }, [_c('h1', {
    staticClass: "m-b-lg"
  }, [_vm._v("A secure solution")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "lead"
  }, [_vm._v("Privacy and security is at the heart of the LogBox products, which is why we take every precaution to secure and protect the personal and health information of each patient.")]), _vm._v(" "), _c('p', [_vm._v("Security concerns are addressed on every level from application infrastructure and authentication to data encryption. Your information is not shared with anyone without your consent.")]), _vm._v(" "), _c('p', [_vm._v("LogBox is Protection of Personal Information (POPI) compliant.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-landing"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {}, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', {}, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', {}, [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', {}, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Learn More")])], 1)])])])])])
}]}

/***/ })
]),[262]);


// WEBPACK FOOTER //
// js/app.6276ab6a2cc8248ec964.js